
import * as THREE from 'three';
import { FikoYTKokBilesenComponent } from '../../../../../../service/kok-bilesen/kok-bilesen.component';
import { FikoThreeJsComponent } from '../fiko-three-js.component';
import { FikoNPRRenderer, NPRMod } from '../IFikoThreeJS/postprocessing/FikoNPRRenderer';
import { Component, computed, signal, Input, ViewChild, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, forwardRef, Inject, inject, EventEmitter, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AgacItemComponent } from './agac-item/agac-item.component';
import { SahneStepViewer } from './sahne-step-viewer/SahneStepViewer';
import { FikoKomutPenceresi } from '../IFikoThreeJS/fiko-modelleme/FikoKomutPenceresi';
import { FikoKomutIcerik } from '../IFikoThreeJS/fiko-modelleme/FikoKomutIcerik';
import { IKomutTanim } from '../IFikoThreeJS/fiko-modelleme/fiko-komut.tanim';
import { komutBul, FIKO_KOMUTLAR } from '../IFikoThreeJS/fiko-modelleme/fiko-komut.registry';
import { FikoImporter, FILE_DIALOG_FORMATS } from '../IFikoThreeJS/FikoImporter';
import { FikoImporterSTP } from '../IFikoThreeJS/FikoImporter.STP';
import { FikoCizimYalin } from '../IFikoThreeJS/FikoCizimYalin';
import { FikoOlcumComponent } from '../IFikoThreeJS/fiko-olcum/fiko-olcum.component';
import { DimensionIntegrationService } from '../IFikoThreeJS/fiko-olcum/dimension/DimensionIntegration.service';
import { FikoAnalizComponent } from '../IFikoThreeJS/fiko-analiz';
import { RadiusAnalysisComponent } from '../IFikoThreeJS/fiko-analiz-radius';
import { FikoDinamikKesitComponent } from '../IFikoThreeJS/fiko-dinamik-kesit';
import { FikoAnnotationToolbarComponent } from '../IFikoThreeJS/fiko-floating-toolbar/fiko-annotation-toolbar.component';
import { FikoTeknikResimToolbarComponent } from '../IFikoThreeJS/fiko-teknik-resim-2d/components/toolbar/fiko-teknik-resim-toolbar.component';
import { FikoCMMDialogComponent } from '../IFikoThreeJS/fiko-cmm';
import { FikoDialogService } from '../../fiko-dialog-core/fiko-dialog.service';
import { FikoCSS3DAnnotationComponent, FikoSmartPointComponent } from '../fiko-annotation';
import { FikoKocKafaDialogComponent, FikoOzmoKafaDialogComponent } from '../fiko-mini-3d';
import { FikoARModu } from '../IFikoThreeJS/FikoARModu';
import { FikoStabilTopoloji } from '../IFikoThreeJS/fiko-stabil-topoloji/FikoStabilTopoloji';
import { FikoStabilTopolojiDebug } from '../IFikoThreeJS/fiko-stabil-topoloji/FikoStabilTopolojiDebug';
import { FikoModellemeYonetici, ModellemeDurum } from '../IFikoThreeJS/fiko-modelleme/FikoModellemeYonetici';
import { FikoParametreWorkbenchComponent } from '../IFikoThreeJS/fiko-modelleme/fiko-parametre-workbench/fiko-parametre-workbench.component';
import { FikoFxEditorComponent } from '../IFikoThreeJS/fiko-modelleme/fiko-parametre-workbench/fiko-fx-editor.component';
import { FikoCamYonetici } from '../IFikoThreeJS/fiko-cam/fiko-cam.yonetici';
import { FikoCamAktivite, FikoCamTakimNode } from '../IFikoThreeJS/fiko-cam/fiko-cam-aktivite';
import { FikoGrup } from '../IFikoThreeJS/FikoGrup';
import { ICamOperasyon, OperasyonTip, FREZE_TIPLER, AXIAL_TIPLER as CAM_AXIAL_TIPLER, OPERASYON_AD } from '../IFikoThreeJS/fiko-cam/fiko-cam.types';
import { FikoOperasyon } from '../IFikoThreeJS/FikoThreeCam/Fikoperasyon';
import { SketchArac } from '../IFikoThreeJS/fiko-modelleme/FikoSketchAraci';
import { FikoYTBildirimService } from '../../../../../../service/fikoyt-bildirim.service';
import { FikoYT3dLineDialogComponent, FikoYT3dLine } from '../IFikoThreeJS/fiko-3d-elements/fikoyt-3d-line';
import { FikoYT3dPolylineDialogComponent, FikoYT3dPolyline } from '../IFikoThreeJS/fiko-3d-elements/fikoyt-3d-polyline';
import { FikoYT3dSplineDialogComponent, FikoYT3dSpline } from '../IFikoThreeJS/fiko-3d-elements/fikoyt-3d-spline';
import { FikoScreenshotComponent, FikoVideoRecordComponent } from '../IFikoThreeJS/fiko-screenshot';
import { FikoMassInfoComponent } from '../IFikoThreeJS/fiko-mass-info';
import { FikoTeklifComponent } from '../IFikoThreeJS/fiko-teklif';
import { FikoFeatureTaniComponent } from '../IFikoThreeJS/fiko-feature-tani';
import { FikoNestingComponent } from '../IFikoThreeJS/fiko-nesting';
import { FikoMuayeneComponent } from '../IFikoThreeJS/fiko-muayene';
import { FikoMalzemeKarsilastirComponent } from '../IFikoThreeJS/fiko-malzeme-karsilastir';
import { FikoIsEmriComponent } from '../IFikoThreeJS/fiko-is-emri';
import { FikoToleransComponent } from '../IFikoThreeJS/fiko-tolerans';
import { FikoKesimComponent } from '../IFikoThreeJS/fiko-kesim';
import { FikoDxfComponent } from '../IFikoThreeJS/fiko-dxf';
import { FikoBukumComponent } from '../IFikoThreeJS/fiko-bukum';
import { FikoKaplamaComponent } from '../IFikoThreeJS/fiko-kaplama';
import { FikoUretimKartiComponent } from '../IFikoThreeJS/fiko-uretim-karti';
import { FikoUretimMenuComponent } from '../IFikoThreeJS/fiko-uretim-menu';
import { FikoTakvimComponent } from '../IFikoThreeJS/fiko-takvim';
import { FikoKesmeParametreComponent } from '../IFikoThreeJS/fiko-kesme-parametre';
import { FikoBirimComponent } from '../IFikoThreeJS/fiko-birim';
import { FikoCivataComponent } from '../IFikoThreeJS/fiko-civata';
import { FikoKayitlarComponent } from '../IFikoThreeJS/fiko-kalicilik';
import { FikoPdfChannelHost, openPdfEditorWindow } from '../IFikoThreeJS/fiko-pdf-export';
import { FikoDFMComponent } from '../IFikoThreeJS/fiko-dfm';
import { FikoScreenshot } from '../IFikoThreeJS/fiko-screenshot';
import { Fiko2DCamComponent } from '../IFikoThreeJS/Fiko-2d-Cam';
import { FikoSimilasyonV1Component } from '../IFikoThreeJS/fiko-similasyon-v1/fiko-similasyon-v1.component';
import { FikoTakimYoluv1 } from '../IFikoThreeJS/FikoThreeCam/FikoTakimYoluv1';
import { FikoVektorTakimYol3Dv1 } from '../IFikoThreeJS/FikoThreeCam/FikoVektorTakimYol3dv1';
import { FikoSPHSiviComponent } from '../IFikoThreeJS/fiko-sph-sivi/components/fiko-sph-sivi.component';
import { FikoDokumKontrolComponent } from '../IFikoThreeJS/fiko-dokum-kontrol/fiko-dokum-kontrol.component';
// FikoTeknikResim artık kullanılmıyor - Teknik resim modu Three.js tabanlı çalışıyor
declare var $: any;

@Component({
  selector: 'fikoyt-3d',
  templateUrl: './.component.html',
  styleUrls: ['./.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    FormsModule,
    FikoThreeJsComponent,
    AgacItemComponent,
    FikoAnnotationToolbarComponent,
    FikoTeknikResimToolbarComponent,
    FikoKomutPenceresi,
    FikoDokumKontrolComponent,
  ]
})
export class FikoYT3DComponent extends FikoYTKokBilesenComponent implements OnDestroy {
  @ViewChild('fikoThreejs', { static: true }) fikoThreejs: FikoThreeJsComponent;
  @ViewChild('annotationToolbarRef') annotationToolbarRef: FikoAnnotationToolbarComponent;
  @ViewChild('teknikResimToolbarRef') teknikResimToolbarRef: FikoTeknikResimToolbarComponent;
  // @ViewChild('fikoKesitDialog', { static: true }) fikoKesitDialog: FikoKesitComponent;
  //--->
  @Input() gosterSolAracCubugu: boolean = true;
  @Input() solAracCubuguAcik: boolean = true;

  @Input() gosterAltAracCubugu: boolean = true;

  /** 🪶 Gömülü mod: kart önizlemesi gibi yerlerde toolbar/panel/dialog UI'sız, sadece canvas+orbit göster */
  @Input() gomulu: boolean = false;
  /** Gömülü modda dış bileşenin doğrudan yükleteceği dosya id'si (route query param'a alternatif — aynı sayfada birden çok kart için gerekli) */
  @Input() dosyaId: string | null = null;
  /** Henüz sunucuya yüklenmemiş yerel dosya (paylaş kutusu → dosya seçildi ama post edilmedi).
   *  Varsa dosyaId yerine bunu kullan: fetch/indirme atlanır, dosya doğrudan FikoImporter'a verilir. */
  @Input() localDosya: File | null = null;
  /** Dosya indirme ilerlemesi (0-100) — gömülü modda parent kartın progress bar için kullanır */
  @Output() dosyaIndirmeProgress = new EventEmitter<{ mesaj: string; progress: number }>();
  listeModuAktif: boolean = false;

  arModu: FikoARModu = new FikoARModu();
  arModuAktif = false;
  arGyroAktif = false;

  /** 🔖 Stabil Topoloji ID registry (Part 1 — salt eklenti, inert) */
  stabilTopoloji = new FikoStabilTopoloji();
  private stabilTopolojiDebug: FikoStabilTopolojiDebug | null = null;
  stabilTopolojiTestAcik = false;

  /** ✏️ CATIA tarzı modelleme (Part 3 — additive, mevcut viewer içinde) */
  modellemeAcik = false;
  geriAlinabilir = signal(false);
  ileriAlinabilir = signal(false);

  /** ⚙️ CATIA Prismatic Machining (yeni CAM sistemi) */
  cam: FikoCamYonetici | null = null;
  camAcik = false;
  modellemeDurum: ModellemeDurum = 'kapali';
  modellemeAktifArac: SketchArac = 'sec';
  modellemeGrid = true;
  private modelleme: FikoModellemeYonetici | null = null;

  // CATIA tarzı flyout komut grupları
  mdlProfilKomutlari = [
    { id: 'cizgi', etiket: 'Çizgi', ikon: 'minus', ks: 'L' },
    { id: 'polyline', etiket: 'Çoklu Çizgi', ikon: 'wave square', ks: 'P' },
    { id: 'dikdortgen', etiket: 'Dikdörtgen', ikon: 'square outline', ks: 'R' },
    { id: 'dikdortgenMerkez', etiket: 'Merkezli Dikdörtgen', ikon: 'th large', ks: 'D' },
    { id: 'cokgen', etiket: 'Çokgen', ikon: 'star outline', ks: 'G' },
    { id: 'cember', etiket: 'Çember', ikon: 'circle outline', ks: 'C' },
    { id: 'cember3n', etiket: 'Çember (3 nokta)', ikon: 'circle', ks: 'O' },
    { id: 'elips', etiket: 'Elips', ikon: 'circle outline', ks: 'E' },
    { id: 'yay', etiket: 'Yay (3 nokta)', ikon: 'dot circle outline', ks: 'A' },
    { id: 'spline', etiket: 'Spline (Esc bitir)', ikon: 'bezier curve', ks: 'J' },
    { id: 'slot', etiket: 'Oval Slot', ikon: 'window minimize outline', ks: 'S' },
    { id: 'nokta', etiket: 'Nokta', ikon: 'crosshairs', ks: 'N' },
    { id: 'insacizgi', etiket: 'İnşa Çizgisi', ikon: 'ellipsis horizontal', ks: 'X' },
    // CATIA hazır profiller + konik (mouse ile yerleştir: merkez/tepe tıkla → boyut tıkla, ghost önizleme)
    { id: 'sablonDik', etiket: 'Yönlü Dikdörtgen', ikon: 'expand', ks: '' },
    { id: 'sablonParalel', etiket: 'Paralelkenar', ikon: 'clone', ks: '' },
    { id: 'sablonKeyhole', etiket: 'Anahtar Deliği', ikon: 'key', ks: '' },
    { id: 'konik', etiket: 'Konik: Parabol', ikon: 'chart line', ks: '' },
    { id: 'konikH', etiket: 'Konik: Hiperbol', ikon: 'chart line', ks: '' },
  ];
  mdlOperasyonKomutlari = [
    { id: 'aynala', etiket: 'Aynala (Mirror)', ikon: 'clone outline' },
    { id: 'offset', etiket: 'Offset (hayalet)', ikon: 'expand' },
    { id: 'otele', etiket: 'Ötele (Translate)', ikon: 'copy outline' },
    { id: 'tasi', etiket: 'Taşı (Translate)', ikon: 'arrows alternate' },
    { id: 'fillet', etiket: 'Köşe Yuvarlat (Fillet)', ikon: 'circle notch' },
    { id: 'corner', etiket: 'Köşe (Corner, R girişli)', ikon: 'circle notched' },
    { id: 'pah', etiket: 'Pah (Chamfer)', ikon: 'cut' },
    { id: 'trim', etiket: 'Buda (Trim)', ikon: 'eraser' },
    { id: 'quickTrim', etiket: 'Hızlı Buda (QuickTrim, zincir)', ikon: 'cut' },
    { id: 'offsetZincir', etiket: 'Offset Zinciri (propagation)', ikon: 'expand' },
    { id: 'konturOtele', etiket: 'Kontur Ötele', ikon: 'expand arrows alternate' },
  ];
  mdlSonProfil = this.mdlProfilKomutlari[0];
  mdlSonOperasyon = this.mdlOperasyonKomutlari[0];
  mdlFlyoutAcik: string | null = null;
  mdlFlyoutPos = { x: 60, y: 200 };  // flyout fixed konumu (overflow'dan kaçar)
  // Ölçü (dimension) overlay
  modellemeOlcuListesi: { id: number; x: number; y: number; metin: string; deger: number; tip: string }[] = [];
  olcuDuzenle: { id: number; deger: number } | null = null;
  private olcuRaf = 0;
  private modellemeKanvasBagli = false;

  /** Yükleme durumu - progress ve mesaj için */
  yuklemeDurumu = {
    aktif: false,
    mesaj: '',
    progress: 0
  };
  //--->
  isFrame = computed(() => {
    return window.self !== window.top;
  })

  private bildirim = inject(FikoYTBildirimService);
  private _sonMotorBildirim = ''; private _sonMotorBildirimZaman = 0;
  /** Motor/durum mesajı → UYGULAMA-İÇİ toast (ntfy telefon push'u DEĞİL). Aynı mesajı 1.5sn içinde tekrarlama (slider/rebuild spam'i engelle). */
  private motorBildir(msg: string): void {
    if (!msg) return;
    const t = performance.now();
    if (msg === this._sonMotorBildirim && t - this._sonMotorBildirimZaman < 1500) return;
    this._sonMotorBildirim = msg; this._sonMotorBildirimZaman = t;
    try { this.nzMessage.info(msg, { nzDuration: 2200 }); } catch { }
  }
  private nprRenderer: FikoNPRRenderer;
  aktifNPRMod: NPRMod = 'pbr';

  /** PDF Editor için BroadcastChannel host */
  private pdfChannelHost: FikoPdfChannelHost | null = null;

  /** 🌳 TREE SYNC: Tree state değişikliklerini dinlemek için subscription */
  private treeStateSubscription: any = null;

  /** Kaydetme işlemi aktif mi (double-click koruması) */
  private _kaydetmeAktif = false;

  constructor(private cd: ChangeDetectorRef,@Inject(forwardRef(() => FikoDialogService)) private DialogFiko: FikoDialogService) {
    super();
    this.nprRenderer = FikoNPRRenderer.getInstance();
    this.aktifNPRMod = this.nprRenderer.getAktifMod();
    // 🔖 DEV: konsoldan anında test → window.fikoStabilTest()
    (window as any).fikoStabilTest = () => this.stabilTopolojiTestToggle();
  }


  /** Henüz sunucuya yüklenmemiş yerel File'ı (paylaş kutusu, upload öncesi) doğrudan sahneye yükler.
   *  dosyaYukle'nin aksine fetch/indirme YOK — dosya zaten tarayıcıda, doğrudan FikoImporter'a verilir. */
  private async yerelDosyaYukle(dosya: File): Promise<void> {
    try {
      if (!this.fikoThreejs?.sahneler?.[0]) {
        setTimeout(() => this.yerelDosyaYukle(dosya), 500);
        return;
      }
      const sahne = this.fikoThreejs.sahneler[0] as any;
      const cizimler = sahne.cizimler;
      if (!cizimler) return;

      // Gömülü modda STP/STEP dosyaları için dialog atla, doğrudan occt-import-js ile aç
      if (this.gomulu && this.isStpFile(dosya.name)) {
        await this.stpDosyasiniDirektYukle(dosya, cizimler);
        return;
      }

      const importer = new FikoImporter(cizimler);
      const sonuc = await importer.dosyalardanYukle([dosya]);

      if (sonuc) {
        this.FikoYT?.degisti?.emit();
        this.fikoThreejs.ciz();
      }
    } catch (err) {
      console.warn('[Fiko3D] Yerel dosya yüklenemedi:', err);
      this.motorBildir('3D içerik yüklenemedi');
    }
  }

  /** Dosya ID'sinden 3D dosyayı indirip sahne yükler */
  private async dosyaYukle(dosyaId: string): Promise<void> {
    try {
      // Önce sahne hazır olmalı
      if (!this.fikoThreejs?.sahneler?.[0]) {
        setTimeout(() => this.dosyaYukle(dosyaId), 500);
        return;
      }

      const sahne = this.fikoThreejs.sahneler[0] as any;
      const cizimler = sahne.cizimler;
      if (!cizimler) return;

      // Dosya URL'ini oluştur
      const dosyaUrl = `${this.FikoYT?.env?.adres?.fapiUrl || ''}/fikoyt.com.FikoYT.sistem.dosyalar.${dosyaId}.dosya`;

      // this.motorBildir('Kart içeriği 3D olarak yükleniyor...');

      // Fetch ile dosyayı al ve File objesine çevir
      const response = await fetch(dosyaUrl);
      if (!response.ok) throw new Error('Dosya indirilemedi');

      // Gerçek dosya adı/uzantısını sunucunun Content-Disposition header'ından oku
      // (backend zaten doğru filename'i gönderiyor — .wrl sabitlemek STEP/OBJ/vb. dosyaları kırıyordu)
      const cd = response.headers.get('content-disposition') || response.headers.get('Content-Disposition');
      const cdMatch = cd?.match(/filename\*?=(?:UTF-8'')?"?([^";]+)"?/i);
      let sunucuAdi = cdMatch ? decodeURIComponent(cdMatch[1]) : null;
      // Backend saklama adı "{dosyaId}{rastgeleSayi}_{orijinalAd}" şeklinde geliyor (örn. "6a963b51...17778_a09013_m01_01.stp")
      // Baştaki id + rastgele sayı + alt çizgiyi temizleyip sadece orijinal dosya adını bırak
      if (sunucuAdi?.startsWith(dosyaId)) {
        sunucuAdi = sunucuAdi.slice(dosyaId.length).replace(/^\d*_/, '');
      }

      // Download progress tracking
      const contentLength = response.headers.get('content-length');
      const totalSize = contentLength ? parseInt(contentLength, 10) : 0;
      const reader = response.body?.getReader();
      const chunks: Uint8Array[] = [];
      let downloaded = 0;

      if (reader) {
        // Progress callback ile indirme
        while (true) {
          const { done, value } = await reader.read();
          if (done) break;
          chunks.push(value);
          downloaded += value.length;
          if (totalSize > 0) {
            const percent = Math.round((downloaded / totalSize) * 100);
            this.dosyaIndirmeProgress.emit({
              mesaj: `İndiriliyor... ${percent}%`,
              progress: percent
            });
          } else {
            // Bilinmeyen boyut — MB bazlı göster
            const mb = (downloaded / (1024 * 1024)).toFixed(1);
            this.dosyaIndirmeProgress.emit({
              mesaj: `İndiriliyor... ${mb} MB`,
              progress: 0
            });
          }
        }
      } else {
        // Reader desteklenmiyor — fallback
        this.dosyaIndirmeProgress.emit({ mesaj: 'İndiriliyor...', progress: 50 });
      }

      // Chunk'ları birleştir
      const blob = new Blob(chunks as BlobPart[]);
      // Sunucudan gerçek dosya adı geldiyse doğrudan onu kullan; gelmediyse eski fallback ismi üret
      const dosyaAdi = sunucuAdi || ('icerik_' + dosyaId + '.wrl');
      const file = new File([blob], dosyaAdi, { type: blob.type });

      // İndirme tamamlandı
      this.dosyaIndirmeProgress.emit({ mesaj: 'İndirildi', progress: 100 });

      // Gömülü modda STP/STEP dosyaları için dialog atla, doğrudan occt-import-js ile aç
      if (this.gomulu && this.isStpFile(dosyaAdi)) {
        await this.stpDosyasiniDirektYukle(file, cizimler);
      } else {
        // FikoImporter ile yükle
        const importer = new FikoImporter(cizimler);
        const sonuc = await importer.dosyalardanYukle([file]);

        if (sonuc) {
          this.FikoYT?.degisti?.emit();
          this.fikoThreejs.ciz();
          // this.motorBildir('3D içerik yüklendi');
        }
      }
    } catch (err) {
      console.warn('[Fiko3D] Dosya yüklenemedi:', err);
      this.motorBildir('3D içerik yüklenemedi');
    }
  }

  /**
   * STP/STEP dosyası kontrolü
   */
  private isStpFile(dosyaAdi: string): boolean {
    const ad = dosyaAdi.toLowerCase();
    return ad.endsWith('.stp') || ad.endsWith('.step');
  }

  /**
   * STP/STEP dosyasını dialog olmadan doğrudan occt-import-js ile yükler.
   * Gömülü mod (kart önizleme) için kullanılır — StpImportDialogComponent atlanır,
   * varsayılan occt-import-js ayarlarıyla açılır.
   */
  private async stpDosyasiniDirektYukle(dosya: File, cizimler: any): Promise<void> {
    try {
      const stpImporter = new FikoImporterSTP(cizimler);
      // Dosya boyutuna göre adaptif tessellation kalitesi uygula (dialog olmadan)
      stpImporter.tessellationKalitesiAyarla('adaptif', dosya.size);

      const sonuc = await stpImporter.yukle(dosya, 'yok');

      if (sonuc) {
        // Array ise tek tek ekle
        if (Array.isArray(sonuc)) {
          sonuc.forEach(item => cizimler.ekle(item));
        } else {
          cizimler.ekle(sonuc);
        }

        // Sahneyi güncelle
        if (cizimler.sahne?.anaGosterim) {
          cizimler.sahne.anaGosterim.FikoYT.degisti.emit();
          cizimler.sahne.anaGosterim.ciz();

          // Model yüklendikten sonra otomatik ekrana sığdır
          setTimeout(() => {
            if (cizimler.sahne && typeof cizimler.sahne.ekranaSigdir === 'function') {
              const objToFit = Array.isArray(sonuc) ? sonuc[0] : sonuc;
              if (objToFit) {
                cizimler.sahne.ekranaSigdir(objToFit);
              }
            }
          }, 100);

          // SPATIAL INDEX: Register edges for O(1) hover lookup
          setTimeout(() => {
            if (cizimler.sahne?.anaGosterim?.secililer) {
              cizimler.sahne.anaGosterim.secililer.registerEdgesForSpatialIndex();
            }
          }, 200);
        }

        this.FikoYT?.degisti?.emit();
        this.fikoThreejs.ciz();
      }
    } catch (err: any) {
      console.error('[Fiko3D] STP direkt yükleme hatası:', err);
      this.dosyaIndirmeProgress.emit({ mesaj: `Hata: ${err?.message || 'Bilinmeyen hata'}`, progress: 0 });
      this.motorBildir(`STP yüklenemedi: ${err?.message || 'Bilinmeyen hata'}`);
    }
  }

  /**
   * 🔖 Stabil Topoloji test toggle (DEV).
   * Sahneyi kaydeder + hover overlay'i aç/kapatır. Mevcut seçim/hover
   * sistemine dokunmaz; kendi raycaster'ı ile çalışır.
   */
  stabilTopolojiTestToggle(): void {
    const kok = () => this.fikoThreejs?.sahneler?.[0] as unknown as THREE.Object3D;
    if (!this.stabilTopolojiDebug) {
      this.stabilTopolojiDebug = new FikoStabilTopolojiDebug(
        this.stabilTopoloji,
        () => this.fikoThreejs?.sunucu?.domElement,
        () => this.fikoThreejs?.aktifKamera,
        kok,
      );
    }
    if (this.stabilTopolojiTestAcik) {
      this.stabilTopolojiDebug.durdur();
      this.stabilTopolojiTestAcik = false;
      this.bildirim.aracKullanildi('Stabil ID testi: kapalı');
    } else {
      const yeni = this.stabilTopoloji.kaydetSahne(kok());
      this.stabilTopolojiDebug.baslat();
      this.stabilTopolojiTestAcik = true;
      this.bildirim.aracKullanildi(`Stabil ID: ${yeni} parça kaydedildi, ${this.stabilTopoloji.yuzSayisi} yüz`);
    }
    this.cd.detectChanges();
  }

  /** Template erişimi: modelleme yöneticisi (lazy oluşturulmamışsa null). Parametre Workbench knowledge köprüsü için. */
  get modellemeAktif(): FikoModellemeYonetici | null { return this.modelleme; }

  // ===== ✏️ CATIA tarzı Modelleme (additive) =====
  private modellemeAl(): FikoModellemeYonetici {
    if (!this.modelleme) {
      const sahne = this.fikoThreejs.sahneler[0] as unknown as THREE.Scene;
      this.modelleme = new FikoModellemeYonetici({
        sahne,
        canvasAl: () => this.fikoThreejs?.sunucu?.domElement,
        kameraAl: () => this.fikoThreejs?.aktifKamera as unknown as THREE.Camera,
        kontrolAl: () => this.fikoThreejs?.aktifKontrol,
        rendererAl: () => this.fikoThreejs?.sunucu,
        ciz: () => this.fikoThreejs.ciz(),
        topo: this.stabilTopoloji,
        degisti: (durum) => {
          this.modellemeDurum = durum;
          if (durum === 'sketch') { this.modellemeAcik = true; this.olcuDonguBaslat(); }
          else { this.olcuDonguDurdur(); }
          this.geriAlinabilir.set(this.modelleme?.geriAlinabilirAktif ?? false);   // mod değişince (sketch↔part) buton durumu
          this.ileriAlinabilir.set(this.modelleme?.ileriAlinabilirAktif ?? false);
          this.cd.detectChanges();
        },
        agacGuncelle: () => this.FikoYT.degisti.emit(),
        bildir: (msg: string) => this.motorBildir(msg),   // motor durum mesajı → uygulama-içi toast (ntfy push DEĞİL)
        gecmisDegisti: (geri: boolean, ileri: boolean) => { this.geriAlinabilir.set(geri); this.ileriAlinabilir.set(ileri); this.cd.detectChanges(); },
      });
      if (typeof ngDevMode !== 'undefined' && ngDevMode) (window as any).__fikoModelleme = this.modelleme;   // DEV-only: konsoldan test (prod'da tree-shake)
      this.modelleme.govdeDegisti = () => this.cam?.modelDegisti();   // CATIA associativity: gövde rebuild → CAM toolpath'leri bayat (⟳) / oto modda yeniden hesap
    }
    if (this.modelleme && this.modelleme.knowledge) this.modelleme.knowledge.fxAc = (paramId: string) => this.fxDialogAc(paramId);
    this.modellemeKanvasBagla();
    return this.modelleme;
  }

  /** Yeni CATIA CAM yöneticisini (lazy) oluştur. */
  camAl(): FikoCamYonetici {
    if (!this.cam) {
      const sahne = this.fikoThreejs.sahneler[0] as unknown as THREE.Scene;
      this.cam = new FikoCamYonetici({
        sahne,
        kameraAl: () => this.fikoThreejs?.aktifKamera as unknown as THREE.Camera,
        canvasAl: () => this.fikoThreejs?.sunucu?.domElement,
        ciz: () => this.fikoThreejs.ciz(),
        bildir: (m: string) => this.motorBildir(m),   // CAM durum mesajı → uygulama-içi toast (ntfy push DEĞİL)
        govdeAl: () => this.camGovdeMeshBul(),
        aktiviteEkle: (op) => this.camAktiviteEkle(op),
        aktiviteSil: (op) => this.camAktiviteSil(op),
        takimAgacEkle: (tk) => this.camTakimAgacEkle(tk),
        takimAgacSil: (tk) => this.camTakimAgacSil(tk),
        agacGuncelle: () => { this.fikoThreejs?.sahneler?.[0]?.anaGosterim?.FikoYT?.degisti?.emit?.(); this.cd.detectChanges(); },
        durumYaz: (json) => { const p = this.camManufProg; if (p) p.userData['FikoCam'] = json; },
        gecmisDegisti: (geri, ileri) => { if (this.camAcik) { this.geriAlinabilir.set(geri); this.ileriAlinabilir.set(ileri); this.cd.detectChanges(); } },
        secimDurum: (d) => { this.camSecimHud = d; this.cd.detectChanges(); },
        brepKontur: (faceId) => { const md: any = this.modelleme; return md?.brepVarMi?.() ? md.yuzBrepKontur(faceId) : null; },   // CATIA: CAM konturu gerçek B-Rep'ten (mesh değil)
        delikAdaylari: () => this.camDelikAdaylari(),   // CATIA otomatik delik tanıma: B-Rep silindirik yüzler
        yuzNormalAl: (fid) => this.camYuzNormal(fid),   // CATIA associative tool axis: faceId → güncel B-Rep yüz normali
        yuzZAl: (fid) => this.camYuzZ(fid),   // CATIA associatif düzlem: faceId → güncel yüz Z'si (güvenlik/yaklaşma/düzleme)
        knowledgeAl: () => (this.modelleme as any)?.knowledge || null,   // parametrik CAM: op alanları knowledge deposunda f(x) formül alabilir
      });
      (this.cam as any)._df = this.DialogFiko;   // operasyon dialog'unu açmak için
      (this.cam as any)._simAc = (n?: any) => this.camSimulasyonAc(n);   // n verilirse sadece o node'un altı simüle edilir (operasyon/takım-yolu)
      (this.cam as any)._copyAc = (op: ICamOperasyon) => this.camCopyAc(op);   // Copy Transformation paneli
      (this.cam as any)._takimDuzenle = (tkId: string) => { const n = this.camTakimNodelar.get(tkId); n?.dialogAc?.(); };   // operasyon takımı → ürün ağacı takım dialoğu (linkli)
      (this.cam as any)._yeniTakim = () => this.camYeniTakim();
      if (typeof ngDevMode !== 'undefined' && ngDevMode) (window as any).__fikoCam = this.cam;
    }
    return this.cam;
  }
  /** CAM update modu (CATIA): Otomatik ↔ Manuel (⟳ bayat işaretle, kullanıcı Hesapla der). */
  camOtoToggle(): void {
    const c = this.camAl(); c.otoGuncelle = !c.otoGuncelle;
    this.bildirim.aracKullanildi('CAM güncelleme: ' + (c.otoGuncelle ? 'Otomatik — model değişince toolpath hemen hesaplanır' : 'Manuel — değişen operasyonlar ⟳ işaretlenir'));
    this.cd.detectChanges();
  }

  /** CATIA: toolpath'ler operasyonların altında (FikoTakimYoluv1). Manufacturing Program'ı FikoSimilasyonV1'e ver → traverse ile tüm yollar toplanır, İşleme Ekseni parent'tan gelir. */
  camSimulasyonAc(hedefNode?: any): void {
    const cam = this.camAl(); cam.hesapla();   // toolpath node'ları operasyon altında kurulur/güncellenir
    const uyarilar = cam.gougeKontrol();
    if (uyarilar.length) { const ilk = uyarilar.slice(0, 3).map(u => u.opAd + ': ' + u.mesaj).join(' • '); this.bildirim.aracKullanildi('⚠ Gouge/çarpma (' + uyarilar.length + '): ' + ilk); }
    const sahne: any = this.fikoThreejs?.sahneler?.[0]; if (!sahne) return;
    // hedefNode verilirse (operasyon/takım-yolu node'u) SADECE onun altındaki toolpath simüle edilir; İşleme Ekseni parent zincirinden gelir.
    const tekNode = !!hedefNode;
    const prog: any = hedefNode || this.camManufProgAl();   // FikoOperasyon (İşleme Ekseni + Nc Programlar altında operasyon→FikoTakimYoluv1)
    let yolVarMi = false; prog.traverse?.((o: any) => { if (o?.noktalar?.length) yolVarMi = true; });
    const varMi = tekNode ? yolVarMi : cam.partOp.operasyonlar.some((o: any) => !o.bastirilmis && o.yolNode?.noktalar?.length);
    if (!varMi) { this.bildirim.aracKullanildi(tekNode ? 'Bu operasyonun takım yolu yok (önce Hesapla)' : 'Önce operasyon ekleyip Hesapla deyin'); return; }
    // Otomatik stok kütüğü (type=FikoKutuk → kutukOtomatikBul bulur)
    this.cam3dStokTemizle();
    const st = cam.partOp.stok;
    if (st) {
      const stokGeo = new THREE.BoxGeometry(st.en, st.boy, st.yuk); stokGeo.translate(st.x + st.en / 2, st.y + st.boy / 2, st.z + st.yuk / 2);
      const stokMesh = new THREE.Mesh(stokGeo, new THREE.MeshStandardMaterial({ color: 0xc7a35a, metalness: 0.1, roughness: 0.85, transparent: true, opacity: 0.55 })); stokMesh.name = 'camStok';
      stokMesh.visible = false;   // ham stok başlangıçta GÖRÜNMEZ — FikoSimilasyonV1 kutukMeshAyarla devralınca opak gösterir
      const ic = new THREE.Group(); ic.add(stokMesh); const stokGrup: any = new THREE.Group(); stokGrup.type = 'FikoKutuk'; stokGrup.add(ic); stokGrup.roughStockResult = { stock: ic };
      sahne.add(stokGrup); this.cam3dStokGrup = stokGrup;
    }
    this.fikoThreejs.ciz?.();
    const baslik = tekNode ? ('Simülasyon — ' + (prog.name || 'Operasyon')) : 'CAM Kütük Simülasyonu';
    this.bildirim.aracKullanildi(tekNode ? ('Simülasyon: ' + (prog.name || 'operasyon')) : 'CAM kütük simülasyonu (Manufacturing Program)…');
    this.komutKampanya('CAM', 'simulasyon', 'Takım Yolu Simülasyonu');
    this.DialogFiko.ac({ bilesen: FikoSimilasyonV1Component, id: 'fiko-cam-similasyon', ayarlar: { baslik, simgeResim: '/simgeler/logo.webp', modalMi: false, sinirlandi: false, boyut: { w: 360, h: 'auto' } }, parametreler: { anaNesne: prog } });
  }
  /** CAM modunu aç/kapat (stok otomatik kurulur, Manufacturing Program ağaca eklenir). */
  camToggle(): void {
    this.camAcik = !this.camAcik;
    if (this.camAcik) {
      const c = this.camAl();
      this.camManufProgAl();
      if (!c.partOp.operasyonlar.length) this.camDurumYukle();   // yüklenmiş proje varsa kaldığı yerden devam
      if (!c.partOp.stok) c.stokOtomatik();
      this.geriAlinabilir.set(c.geriAlinabilir); this.ileriAlinabilir.set(c.ileriAlinabilir);
      this.bildirim.aracKullanildi('2D CAM (Prismatic Machining) — alttaki ribbondan operasyon ekleyin');
    } else { this.cam?.replayDurdur(); this.cam?.camSecimBitir(); this.cam?.gorselTemizle(); this.cam3dStokTemizle(); }   // kapanışta seçim/makro listener + saydam stok kütüğünü bırak
    this.cd.detectChanges();
  }

  // ───────── 2D CAM ribbon + ürün ağacı entegrasyonu ─────────
  readonly camFrezeTipler = FREZE_TIPLER;
  // Axial op'lar kategori flyout'larına bölünür (17 op → 5 kompakt kategori — ribbon kalabalığı azalır)
  readonly camAxialKat: { ad: string; ikon: string; ops: OperasyonTip[] }[] = [
    { ad: 'Delme', ikon: 'arrow down', ops: ['spotDrill', 'drilling', 'deepHole', 'breakChips'] },
    { ad: 'Diş', ikon: 'spinner', ops: ['tapping', 'reverseTap', 'threadNoTap', 'threadMilling'] },
    { ad: 'Bara·Rayba', ikon: 'circle notch', ops: ['boring', 'boringChamfer', 'boringStop', 'backBore', 'reaming'] },
    { ad: 'Havşa', ikon: 'caret square down', ops: ['counterBore', 'counterSink', 'chamfer2'] },
    { ad: 'Özel', ikon: 'subscript', ops: ['tslotting'] },
  ];
  camAcikKat: string | null = null;
  camFlyKonum = { x: 0, y: 0 };   // flyout fixed konumu (ribbon çerçevesinden taşabilsin)
  camKatToggle(ad: string, ev?: Event): void {
    this.camAcikKat = this.camAcikKat === ad ? null : ad;
    if (this.camAcikKat && ev) { const r = (ev.currentTarget as HTMLElement).getBoundingClientRect(); this.camFlyKonum = { x: r.left + r.width / 2, y: window.innerHeight - r.top + 6 }; }
    this.cd.detectChanges();
  }
  get camAktifKatOps(): OperasyonTip[] { return this.camAxialKat.find(k => k.ad === this.camAcikKat)?.ops || []; }
  camKatOp(t: OperasyonTip): void { this.camOpEkle(t); this.camAcikKat = null; this.cd.detectChanges(); }
  readonly camAxialTipler = CAM_AXIAL_TIPLER;
  camCikti: { baslik: string; metin: string } | null = null;
  camCopy: { op: ICamOperasyon; tip: 'translate' | 'rotate' | 'symmetry'; adet: number; dx: number; dy: number; aci: number; mx: number; my: number; aynaEksen: 'x' | 'y' } | null = null;
  camSecimHud: { mod: 'nokta' | 'kontur' | 'ada' | 'toolaxis' | 'kenar' | 'duzlem' | 'noktaref'; opAd: string; sayi: number; ek?: string } | null = null;
  readonly camHudBilgi: Record<string, { ikon: string; ad: string; ipucu: string; renk: string }> = {
    nokta: { ikon: '🎯', ad: 'DELİK MERKEZİ SEÇİMİ', ipucu: '👉 3D parçada DELİK MERKEZLERİNE tıkla — işlenecek delikler eklenir (bitir: tekrar Seç)', renk: '#34d399' },
    kontur: { ikon: '⬚', ad: 'KONTUR / PROFİL SEÇİMİ', ipucu: '👉 3D parçada İŞLENECEK YÜZE tıkla — yüzün sınırı kontur olarak alınır', renk: '#38bdf8' },
    ada: { ikon: '🏝', ad: 'ADA (ISLAND) SEÇİMİ', ipucu: '👉 Cep İÇİNDEKİ ADA yüzüne tıkla — takım etrafından dolaşır, ada işlenmez', renk: '#ff8c1a' },
    kenar: { ikon: '╱', ad: 'KENAR SEÇİMİ', ipucu: '👉 İşlenecek KENARLARA sırayla tıkla — zincirlenip tek kontur olur (bitir: tekrar Seç)', renk: '#a78bfa' },
    toolaxis: { ikon: '⊥', ad: 'TAKIM YÖNÜ SEÇİMİ', ipucu: '👉 Bir YÜZE tıkla — yüzün normali takım ekseni (tool axis) olur', renk: '#f472b6' },
    duzlem: { ikon: '▱', ad: 'DÜZLEM / LİMİT SEÇİMİ', ipucu: '👉 Bir YÜZE/düzleme tıkla — o düzlemin Z kotu güvenlik/limit olarak alınır (referanslı)', renk: '#5eead4' },
    noktaref: { ikon: '⛳', ad: 'SINIR NOKTASI SEÇİMİ', ipucu: '👉 Profil üzerinde/parçada bir NOKTAYA tıkla — işlemenin başlama/bitiş sınırı olur', renk: '#fbbf24' },
  };
  private camManufProg: FikoOperasyon | null = null;
  private readonly camIkonMap: Partial<Record<OperasyonTip, string>> = {
    facing: 'th', pocketing: 'clone outline', contouring: 'crosshairs', curveFollow: 'route', pointToPoint: 'ellipsis horizontal', circularMill: 'circle outline',
    spotDrill: 'dot circle', drilling: 'arrow down', deepHole: 'angle double down', breakChips: 'sort amount down', tapping: 'spinner', reverseTap: 'redo',
    threadNoTap: 'at', boring: 'circle notch', boringChamfer: 'circle', boringStop: 'stop circle', reaming: 'circle thin', counterBore: 'dot circle outline', counterSink: 'caret down', chamfer2: 'caret square down', backBore: 'level up alternate', tslotting: 'subscript', threadMilling: 'cog',
  };
  camOpAd(t: OperasyonTip): string { return OPERASYON_AD[t]; }
  camOpKisa(t: OperasyonTip): string { return OPERASYON_AD[t].split(' ')[0]; }
  camOpIkon(t: OperasyonTip): string { return this.camIkonMap[t] || 'wrench'; }

  /** Manufacturing Program node'unu (FikoOperasyon) ürün ağacında bul/oluştur. */
  private camManufProgAl(): FikoOperasyon {
    if (this.camManufProg && this.camManufProg.parent) return this.camManufProg;
    const sahne: any = this.fikoThreejs?.sahneler?.[0];
    // Yüklenmiş projede mevcut Manufacturing Program var mı? (userData.FikoCam ya da ad eşleşmesi)
    let mevcut: FikoOperasyon | null = null;
    sahne?.urunAgaci?.traverse?.((o: any) => { if (!mevcut && o.type === 'Fikoperasyon' && (o.userData?.['FikoCam'] || o.name === 'Manufacturing Program')) mevcut = o; });
    if (mevcut) { this.camManufProg = mevcut; return mevcut; }
    const op = new FikoOperasyon(sahne, 'Manufacturing Program');
    const kok = sahne?.urunAgaci; (kok?.ekle ? kok.ekle(op) : sahne?.add?.(op));
    this.camManufProg = op;
    sahne?.anaGosterim?.FikoYT?.degisti?.emit?.();
    return op;
  }
  /** Yüklenmiş projedeki CAM durumunu (userData.FikoCam) geri kur — kaldığı yerden devam. */
  private camDurumYukle(): void {
    const prog = this.camManufProg; if (!prog || !this.cam) return;
    const json = prog.userData?.['FikoCam']; if (!json?.partOp) return;
    const progra: any = prog.programlar;   // yüklemeden gelen placeholder node'ları temizle
    if (progra) for (let i = progra.children.length - 1; i >= 0; i--) { if (progra.children[i].type === 'FikoCamAktivite') progra.remove(progra.children[i]); }
    this.cam.deserialize(json);
    this.cam.gecmisSifirla();
  }
  /** CAM yöneticisi callback'i: operasyonu ağaca aktivite node'u olarak ekle. */
  private camAktiviteEkle(op: ICamOperasyon): any {
    const prog = this.camManufProgAl();
    const node = new FikoCamAktivite(prog.sahne as any, op, this.cam);
    prog.programlar.ekle!(node);
    return node;
  }
  /** CAM yöneticisi callback'i: aktivite node'unu ağaçtan kaldır. */
  private camAktiviteSil(op: ICamOperasyon): void {
    const node = op.node; if (node?.parent) node.parent.remove(node);
  }

  // ── Takım kaynağı ağaç node'ları (CATIA Resource List) ──
  private camTakimNodelar = new Map<string, any>();
  private camTakimKaynagi: FikoGrup | null = null;
  private camTakimKaynagiAl(): any {
    if (this.camTakimKaynagi && this.camTakimKaynagi.parent) return this.camTakimKaynagi;
    const prog = this.camManufProgAl();
    let grp: any = null;
    prog.traverse?.((o: any) => { if (!grp && o.type === 'FikoGrup' && o.name === 'Takımlar') grp = o; });
    if (!grp) { grp = new FikoGrup(prog.sahne as any, 'Takımlar'); grp.userData['FikoArayuz'].simge = './simgeler/takim.svg'; (prog.ekle ? prog.ekle(grp) : prog.add(grp)); }
    this.camTakimKaynagi = grp; return grp;
  }
  private camTakimAgacEkle(tk: any): any {
    const kaynak = this.camTakimKaynagiAl();
    const node = new FikoCamTakimNode(kaynak.sahne as any, tk, this.cam);
    (kaynak.ekle ? kaynak.ekle(node) : kaynak.add(node));
    this.camTakimNodelar.set(tk.id, node);
    return node;
  }
  private camTakimAgacSil(tk: any): void {
    const node = this.camTakimNodelar.get(tk.id); if (node?.parent) node.parent.remove(node);
    this.camTakimNodelar.delete(tk.id);
  }
  /** CAM açılışında mevcut tüm takımları ağaca kaynak node'u olarak bas (bir kez). */
  private camTakimleriniKur(): void {
    const c = this.camAl(); if (this.camTakimNodelar.size) return;
    for (const tk of c.takimlar) this.camTakimAgacEkle(tk);
    this.fikoThreejs?.sahneler?.[0]?.anaGosterim?.FikoYT?.degisti?.emit?.();
  }
  /** Yeni takım ekle + dialoğunu aç (CATIA New Tool). */
  camYeniTakim(): void {
    const tk = this.camAl().takimEkle('endMill', 8, 'Yeni Takım');
    const node = this.camTakimNodelar.get(tk.id); node?.dialogAc?.();
    this.cd.detectChanges();
  }

  camOpEkle(tip: OperasyonTip): void {
    const c = this.camAl(); if (!c.partOp.stok) c.stokOtomatik();
    const op = c.operasyonEkle(tip);
    op.node?.dialogAc?.();   // CATIA: operasyon eklenince pencere açılır
    this.cd.detectChanges();
  }
  camStok(): void { this.camAl().stokOtomatik(); this.bildirim.aracKullanildi('Stok kütüğü oluşturuldu'); this.cd.detectChanges(); }
  /** Part Operation Setup penceresi (makine/work offset/malzeme/güvenlik Z/stok/eksen). */
  camPartOpAc(): void { this.camAl().partOpDialogAc(); }
  camHesapla(): void { this.camAl().hesapla(); this.bildirim.aracKullanildi('Tüm operasyonlar hesaplandı'); this.cd.detectChanges(); }
  camReplay(): void { this.camSimulasyonAc(); }   // CATIA: replay = FikoSimilasyonV1 (toolpath'ler operasyon altında)
  camSimule(): void { this.camSimulasyonAc(); }
  camCiktiGoster(tip: 'gcode' | 'apt' | 'dok'): void {
    const c = this.camAl(); this.camCopy = null;
    this.camCikti = {
      baslik: tip === 'gcode' ? 'G-CODE (ISO/Fanuc — ikincil)' : tip === 'apt' ? 'APT — Birincil NC Formatı' : 'OPERASYON DOKÜMANI',
      metin: tip === 'gcode' ? c.gcodeUret() : tip === 'apt' ? c.aptUret() : c.dokumanUret(),
    };
    this.cd.detectChanges();
  }
  camCiktiKopyala(): void { if (this.camCikti) { try { navigator.clipboard.writeText(this.camCikti.metin); this.bildirim.aracKullanildi('Panoya kopyalandı'); } catch (e) {} } }
  /** Çıktıyı dosya olarak indir (APT → .aptsource, G-code → .nc, doküman → .txt). */
  camCiktiIndir(): void {
    if (!this.camCikti) return;
    const uz = this.camCikti.baslik.startsWith('G-CODE') ? '.nc' : this.camCikti.baslik.startsWith('APT') ? '.aptsource' : '.txt';
    const ad = (this.camAl().partOp.ad || 'FikoYT_NC').replace(/[^\w.-]+/g, '_') + uz;
    const a = document.createElement('a');
    a.href = URL.createObjectURL(new Blob([this.camCikti.metin], { type: 'text/plain' }));
    a.download = ad; a.click(); URL.revokeObjectURL(a.href);
    this.bildirim.aracKullanildi('NC çıktı indirildi: ' + ad);
  }
  // ── Copy Transformation (CATIA): operasyonu öteleme/dönüş/ayna ile çoğalt ──
  camCopyAc(op: ICamOperasyon): void { this.camCikti = null; this.camCopy = { op, tip: 'translate', adet: 1, dx: 20, dy: 0, aci: 90, mx: 0, my: 0, aynaEksen: 'x' }; this.cd.detectChanges(); }
  camCopyUygula(): void { if (!this.camCopy) return; const { op, ...p } = this.camCopy; this.camAl().kopyalaDonustur(op, p as any); this.camCopy = null; this.cd.detectChanges(); }
  camCopyKapat(): void { this.camCopy = null; this.cd.detectChanges(); }
  camGougeKontrol(): void {
    const u = this.camAl().gougeKontrol(); this.camCopy = null;
    this.camCikti = { baslik: '🛡 Gouge / Çarpma Kontrolü', metin: u.length ? u.map(x => '⚠ [' + x.tip.toUpperCase() + '] ' + x.opAd + '\n   ' + x.mesaj).join('\n\n') : '✓ Sorun bulunamadı — tüm operasyonlar güvenli.' };
    this.cd.detectChanges();
  }

  /** Kanvasa context-menü dinleyicileri (sağ tık + uzun bas) — bir kez. */
  private modellemeKanvasBagla(): void {
    if (this.modellemeKanvasBagli) return;
    const c = this.fikoThreejs?.sunucu?.domElement;
    if (!c) return;
    this.modellemeKanvasBagli = true;
    // MEVCUT sağ-menü sistemine (FikoSecililer.sagMenuAc + itemMenu) bağla — yeni menü YOK
    c.addEventListener('contextmenu', (e: MouseEvent) => {
      if (!this.modellemeAcik) return;
      if (this.modelleme?.secimAktif) { this.modelleme.secimBitir(); e.preventDefault(); return; }   // ardışık 3D çizimi/seçimi sağ-tık bitirir
      const acildi = this.modellemeDurum === 'sketch' ? this.modelleme?.sketchSagMenu(e) : this.modelleme?.govdeSagMenu(e);
      if (acildi) e.preventDefault();
    });
    // CATIA seçim — MERKEZİ tek giriş: tüm tür-bazlı pick'ler (wireframe/kenar/yüz/vertex/profil/hedef/hole) secimPick'ten geçer
    c.addEventListener('pointerdown', (e: PointerEvent) => {
      if (!this.modellemeAcik || e.button !== 0) return;
      if (this.modelleme?.secimAktif && this.modelleme.secimPick(e)) { e.preventDefault(); e.stopPropagation(); }
    }, true);
    // PROFESYONEL HOVER: imleç altındaki kenar/yüz/vertex anlık vurgu (CATIA/Fusion tarzı)
    c.addEventListener('pointermove', (e: PointerEvent) => {
      if (!this.modellemeAcik || !this.modelleme) return;
      if (this.modelleme.topoSecimAktif) this.modelleme.topoHover(e);
      else if (this.modelleme.merkeziSecimAktif) this.modelleme.secimHover(e);   // komut penceresi düzlem/eksen/yüz seçimi
    }, { passive: true });
    let t: any, sx = 0, sy = 0;
    c.addEventListener('pointerdown', (e: PointerEvent) => {
      if (!this.modellemeAcik) return;
      const sketchSec = this.modellemeDurum === 'sketch' && this.modellemeAktifArac === 'sec';
      const partDesign = this.modellemeDurum !== 'sketch';
      if (sketchSec || partDesign) {
        sx = e.clientX; sy = e.clientY; clearTimeout(t);
        t = setTimeout(() => sketchSec ? this.modelleme?.sketchSagMenu(e) : this.modelleme?.govdeSagMenu(e), 480);
      }
    });
    c.addEventListener('pointermove', (e: PointerEvent) => { if (Math.hypot(e.clientX - sx, e.clientY - sy) > 6) clearTimeout(t); }, { passive: true });
    c.addEventListener('pointerup', () => clearTimeout(t));
    // Geri/İleri Al klavye kısayolları (Ctrl+Z / Ctrl+Y / Ctrl+Shift+Z) — modelleme açık + metin alanı dışında
    window.addEventListener('keydown', (e: KeyboardEvent) => {
      if (!this.modellemeAcik || !(e.ctrlKey || e.metaKey)) return;
      const hedef = e.target as HTMLElement;
      if (hedef && /^(INPUT|TEXTAREA|SELECT)$/.test(hedef.tagName)) return;   // form alanında karışma
      const k = e.key.toLowerCase();
      if (k === 'z' && !e.shiftKey) { e.preventDefault(); this.modellemeGeriAl(); }
      else if (k === 'y' || (k === 'z' && e.shiftKey)) { e.preventDefault(); this.modellemeIleriAl(); }
    });
  }

  /** Ölçü etiketine sağ tık → MEVCUT sağ-menü (sagMenuAc). */
  olcuSagMenu(ev: MouseEvent, o: any): void {
    ev.preventDefault(); ev.stopPropagation();
    const secimler = (this.fikoThreejs?.sahneler?.[0] as any)?.secimler;
    if (!secimler) return;
    secimler.sagMenuAc(ev, {
      name: 'Ölçü: ' + o.metin,
      userData: { FikoArayuz: { simge: './simgeler/line.webp' } },
      sagMenu: [
        { baslik: 'Değiştir', simge: 'edit', tiklandi: () => this.olcuCiftTik(o) },
        { tipi: 'Ayraç' },
        { baslik: 'Sil', simge: 'trash alternate', tiklandi: () => this.modellemeAl().olcuSil(o.id) },
      ],
    });
  }

  modellemeToggle(): void {
    this.modellemeAcik = !this.modellemeAcik;
    if (this.modellemeAcik) { const m = this.modellemeAl(); m.modBaslat(); m.gecmisSifirla(); this.bildirim.aracKullanildi('Modelleme modu açık'); }
    else { this.modelleme?.iptalSketch(); this.modellemeDurum = 'kapali'; this.modellemeAktifArac = 'sec'; }
    this.cd.detectChanges();
  }
  modellemeGeriAl(): void { if (this.camAcik && this.cam) this.cam.geriAl(); else this.modellemeAl().geriAlAktif(); this.cd.detectChanges(); }
  modellemeIleriAl(): void { if (this.camAcik && this.cam) this.cam.ileriAl(); else this.modellemeAl().ileriAlAktif(); this.cd.detectChanges(); }

  /** Kayıttan parametrik modeli geri yükler (FikoSahne içindeki modelleme verisi). buffers: import B-Rep (STEP) için binary. */
  async modellemeDeserialize(data: any, buffers?: Uint8Array[]): Promise<void> {
    if (!data) return;
    this.modellemeAcik = true;
    await this.modellemeAl().deserialize(data, buffers);
    this.bildirim.aracKullanildi('Parametrik model yüklendi');
    this.cd.detectChanges();
  }

  /** Kayıttan kalıcı ölçümleri geri yükler — AYNI constructor (DimensionIntegrationService) ile
   *  GERÇEK ölçüm objesi üretir (sabit-boyut etiket + birebir görünüm), sonra "Kalıcı Ölçümler"e taşır. */
  olcumDeserialize(kayitlar: any[]): void {
    if (!kayitlar?.length) return;
    const fikoSahne: any = this.fikoThreejs?.sahneler?.[0];
    if (!fikoSahne) return;
    try {
      let ko: any = null;
      fikoSahne.traverse?.((o: any) => { if (o.type === 'FikoKaliciOlcumler') ko = o; });

      const svc = new DimensionIntegrationService();
      svc.initialize(fikoSahne, fikoSahne);           // gerçek dimension manager (sabit-boyut etiket dahil)
      const mgr: any = svc.getManager?.();
      const V = (a: number[]) => new THREE.Vector3().fromArray(a);

      for (const r of kayitlar) {
        try {
          const oncekiDims: any[] = mgr?.getAllDimensions?.() ? [...mgr.getAllDimensions()] : [];
          // AYNI constructor ile üret (ölçüldüğü gibi)
          if (r.tip === 'cap') {
            svc.createDiameterMeasurement(V(r.merkez), r.yaricap, r.normal ? V(r.normal) : undefined,
              { birim: r.birim, hassasiyet: r.hassasiyet, capUc1: r.n1 ? V(r.n1) : undefined, capUc2: r.n2 ? V(r.n2) : undefined });
          } else if (r.n1 && r.n2) {
            svc.createDistanceMeasurement(V(r.n1), V(r.n2), { birim: r.birim, hassasiyet: r.hassasiyet, olcumTuru: r.tip });
          } else continue;
          // yeni üretilen dimension'ı bul → "Kalıcı Ölçümler"e taşı (ağaçta görünür + kalıcı)
          const sonrakiDims: any[] = mgr?.getAllDimensions?.() || [];
          const yeni: any = sonrakiDims.find(d => !oncekiDims.includes(d));
          if (yeni && ko) {
            // 🎯 Düzenleme menüsü (sagMenu/Düzenle) + sabit-boyut + re-capture için kaliciOlcumEkle kullan
            // (ko.add yerine) → yüklenen ölçüm de SAĞ-TIK/UZUN-BAS ile parametrik düzenlenebilir olur.
            yeni.userData = { ...(yeni.userData || {}), startPoint: V(r.n1), endPoint: V(r.n2), olcumTipi: r.tip, gercekDeger: r.deger, sabitBoyut: true };
            if (r.tip === 'cap') { yeni.userData.merkez = V(r.merkez); yeni.userData.yaricap = r.yaricap; }
            ko.kaliciOlcumEkle(yeni, r.baslik || 'Ölçüm', '');   // sagMenu + ağaç + olcumKayitlari (re-save)
          }
        } catch (e) { /* tek ölçüm hatası diğerlerini durdurmasın */ }
      }
      if (ko?.userData?.FikoArayuz) ko.userData.FikoArayuz.listeGoster = true;
      this.FikoYT?.degisti?.emit();
      this.fikoThreejs.ciz();
    } catch (e) { console.warn('[Yükle] ölçüm geri yükleme hatası', e); }
  }

  modellemeSketchYuz(): void { this.modellemeAl().yuzSecimiBaslat(); }
  modellemeTemel(tip: 'xy' | 'xz' | 'yz'): void { this.modellemeAl().temelDuzlem(tip); }
  modellemeArac(a: SketchArac): void { this.modellemeAktifArac = a; this.modellemeAl().aracSec(a); this.mdlSayisalGiris = {}; }

  // ── Sayısal giriş (CATIA Sketch Tools): çizerken uzunluk/açı/yarıçap yaz ──
  mdlSayisalGiris: Record<string, any> = {};
  get mdlSayisalAlanlar(): { anahtar: string; etiket: string; deger: number; birim: string }[] {
    return this.modellemeAcik && this.modellemeDurum === 'sketch' ? this.modellemeAl().sketchSayisalAlanlar : [];
  }
  /** Sayısal panel imleç konumu (sağ-alt offset, ekran sınırlarına sığar). */
  get mdlSayisalPos(): { x: number; y: number } {
    const p = this.modellemeAl().sketchMouseEkran;
    const w = typeof window !== 'undefined' ? window.innerWidth : 1920, h = typeof window !== 'undefined' ? window.innerHeight : 1080;
    if (!p) return { x: w / 2, y: 80 };
    return { x: Math.min(p.x + 18, w - 320), y: Math.min(p.y + 18, h - 70) };
  }
  mdlSayisalUygula(): void {
    const vals: Record<string, number> = {};
    for (const a of this.mdlSayisalAlanlar) { const v = this.mdlSayisalGiris[a.anahtar]; if (v !== '' && v != null && !isNaN(+v)) vals[a.anahtar] = +v; }
    if (!Object.keys(vals).length) return;
    this.modellemeAl().sketchSayisalUygula(vals);
    this.mdlSayisalGiris = {};
    this.cd.detectChanges();
  }
  modellemeAynala(): void { this.modellemeAktifArac = 'sec'; this.modellemeAl().islemBaslat('aynala'); this.bildirim.aracKullanildi('Aynala: eksen çizgisini seç'); }
  modellemeOtele(): void { this.modellemeAktifArac = 'sec'; this.modellemeAl().islemBaslat('otele'); this.bildirim.aracKullanildi('Öteleme: eleman seç, sonra mesafeye tıkla'); }
  modellemeOffset(): void { this.modellemeAktifArac = 'sec'; this.modellemeAl().islemBaslat('offset'); this.bildirim.aracKullanildi('Offset: kontur seç → mouse ile hayalet → tıkla uygula'); }
  modellemeTasi(): void { this.modellemeAktifArac = 'sec'; this.modellemeAl().islemBaslat('tasi'); this.bildirim.aracKullanildi('Taşı: eleman seç, başlangıç ve bitiş noktasına tıkla'); }
  modellemeFillet(): void { this.modellemeAktifArac = 'sec'; this.modellemeAl().islemBaslat('fillet'); this.bildirim.aracKullanildi('Köşe yuvarlat: köşeyi paylaşan iki çizgiyi seç'); }
  modellemePah(): void { this.modellemeAktifArac = 'sec'; this.modellemeAl().islemBaslat('pah'); this.bildirim.aracKullanildi('Pah: köşeyi paylaşan iki çizgiyi seç'); }
  modellemeTrim(): void { this.modellemeAktifArac = 'sec'; this.modellemeAl().islemBaslat('trim'); this.bildirim.aracKullanildi('Buda: kırpılacak çizgi parçasına tıkla'); }
  modellemeKonturOtele(): void { const ok = this.modellemeAl().konturOtele(-12); this.bildirim.aracKullanildi(ok ? 'Kontur ötelendi (12 birim içe)' : 'Ötelenecek kapalı kontur yok'); }
  modellemeOlcu(): void { this.modellemeAktifArac = 'sec'; this.modellemeAl().islemBaslat('olcu'); this.bildirim.aracKullanildi('Ölçü: eleman seç → etikete çift-tıkla değiştir'); }

  // ölçü etiketleri canlı konum döngüsü (kamera hareketinde takip)
  private olcuDonguBaslat(): void {
    cancelAnimationFrame(this.olcuRaf);
    const tik = () => {
      const c = this.fikoThreejs?.sunucu?.domElement;
      if (c && this.modelleme) {
        const yeni = this.modelleme.olcuEkranListesi(c);
        if (yeni.length || this.modellemeOlcuListesi.length) { this.modellemeOlcuListesi = yeni; this.cd.detectChanges(); }
      }
      if (this.modellemeDurum === 'sketch') this.olcuRaf = requestAnimationFrame(tik);
    };
    this.olcuRaf = requestAnimationFrame(tik);
  }
  private olcuDonguDurdur(): void { cancelAnimationFrame(this.olcuRaf); this.modellemeOlcuListesi = []; this.olcuDuzenle = null; }
  olcuCiftTik(o: any): void { this.olcuDuzenle = { id: o.id, deger: o.deger }; this.cd.detectChanges(); }
  olcuKaydet(): void { if (this.olcuDuzenle) { this.modellemeAl().olcuDegistir(this.olcuDuzenle.id, +this.olcuDuzenle.deger); this.olcuDuzenle = null; this.cd.detectChanges(); } }
  olcuIptalEt(): void { this.olcuDuzenle = null; this.cd.detectChanges(); }

  // Flyout menü kontrolü
  mdlFlyoutToggle(grup: string, ev?: MouseEvent): void {
    if (this.mdlFlyoutAcik === grup) { this.mdlFlyoutAcik = null; }
    else {
      this.mdlFlyoutAcik = grup;
      const b = (ev?.currentTarget as HTMLElement)?.getBoundingClientRect();
      if (b) this.mdlFlyoutPos = { x: Math.round(b.left + b.width / 2), y: Math.round(b.top - 8) };
    }
    this.cd.detectChanges();
  }
  mdlProfilSec(k: any): void {
    this.mdlFlyoutAcik = null;
    this.mdlSonProfil = k;
    if (k.id === 'konik' || k.id === 'konikH') {   // konik alt türü ayarla → interaktif çiz
      this.modellemeAl().konikTipiAyarla(k.id === 'konikH' ? 'hiperbol' : 'parabol');
      this.modellemeArac('konik');
      this.bildirim.aracKullanildi(`${k.etiket}: tepe noktasına tıkla, sonra boyut için tıkla`);
      return;
    }
    if (k.id.startsWith('sablon')) this.bildirim.aracKullanildi(`${k.etiket}: merkeze tıkla, sonra boyut için tıkla (mouse ile)`);
    this.modellemeArac(k.id);
  }
  mdlOperasyonSec(k: any): void {
    this.mdlSonOperasyon = k; this.mdlFlyoutAcik = null;
    ({ aynala: () => this.modellemeAynala(), offset: () => this.modellemeOffset(), otele: () => this.modellemeOtele(), tasi: () => this.modellemeTasi(),
       fillet: () => this.modellemeFillet(), pah: () => this.modellemePah(), trim: () => this.modellemeTrim(),
       corner: () => { this.modellemeAktifArac = 'sec'; this.modellemeAl().islemBaslat('corner'); this.bildirim.aracKullanildi(`Köşe (R=${this.modelleme?.cornerR}): iki çizgi/köşe seç — R'yi sayısal panelden değiştir`); },
       quickTrim: () => { this.modellemeAktifArac = 'sec'; this.modellemeAl().islemBaslat('quickTrim'); this.bildirim.aracKullanildi('Hızlı Buda: silinecek parçalara art arda tıkla (Esc çıkış)'); },
       offsetZincir: () => { this.modellemeAktifArac = 'sec'; this.modellemeAl().islemBaslat('offsetZincir'); this.bildirim.aracKullanildi('Offset Zinciri: çizgi seç → bağlı tüm zincir ötelenir'); },
       konturOtele: () => this.modellemeKonturOtele() } as any)[k.id]?.();
  }
  // CATIA tarzı geometrik kısıtlar (eleman seç → kısıt uygula)
  mdlKisitKomutlari = [
    { id: 'kcakisik', etiket: 'Çakışık (Coincident)', ikon: 'dot circle' },
    { id: 'kparalel', etiket: 'Paralel', ikon: 'equals' },
    { id: 'kdik', etiket: 'Dik (Perpendicular)', ikon: 'plus' },
    { id: 'kteget', etiket: 'Teğet (Tangent)', ikon: 'circle notched' },
    { id: 'kesit', etiket: 'Eşit (Equal)', ikon: 'balance scale' },
    { id: 'kesmerkez', etiket: 'Eşmerkez (Concentric)', ikon: 'bullseye' },
    { id: 'ksimetri', etiket: 'Simetri', ikon: 'exchange' },
    { id: 'kcontact', etiket: 'Akıllı Kısıt (Contact)', ikon: 'magic' },
    { id: 'ksimetri3', etiket: 'Simetri (2 nokta + eksen)', ikon: 'exchange' },
    { id: 'kortanokta', etiket: 'Orta Nokta (nokta + 2 uç)', ikon: 'arrows alternate horizontal' },
    { id: 'kesitmesafe', etiket: 'Eşit Mesafe (3 nokta)', ikon: 'arrows alternate' },
    { id: 'kyatay', etiket: 'Yatay', ikon: 'minus' },
    { id: 'kdikey', etiket: 'Dikey', ikon: 'grip lines vertical' },
  ];
  mdlSonKisit = this.mdlKisitKomutlari[0];
  mdlKisitSec(k: any): void { this.mdlSonKisit = k; this.mdlFlyoutAcik = null; this.modellemeKisit(k.id, k.etiket); }
  private modellemeKisit(tip: string, etiket: string): void {
    this.modellemeAktifArac = 'sec';
    this.modellemeAl().islemBaslat(tip as any);
    const uc3 = ['ksimetri3', 'kortanokta', 'kesitmesafe'].includes(tip);
    const tek = ['kyatay', 'kdikey'].includes(tip);
    this.bildirim.aracKullanildi(`${etiket}: ${uc3 ? 'sırayla 3 öğe seç' : tek ? 'bir çizgi seç' : 'iki eleman seç'}`);
  }
  // CATIA: Auto Constraint (toplu otomatik kısıt) + Sketch Analysis (açık profil)
  modellemeOtoKisit(): void { const n = this.modellemeAl().otoKisitlaTumu(); this.bildirim.aracKullanildi(n ? `${n} otomatik kısıt eklendi` : 'Eklenecek otomatik kısıt bulunamadı'); this.cd.detectChanges(); }
  modellemeOtoOlcu(): void { const n = this.modellemeAl().otoOlcule(); this.bildirim.aracKullanildi(n ? `${n} ölçü-kısıtı eklendi (tam tanımlamaya yakın)` : 'Eklenecek ölçü bulunamadı'); this.cd.detectChanges(); }
  modellemeSketchAnaliz(): void { this.modellemeAl().sketchAcikUclariIsaretle(); this.cd.detectChanges(); }
  // CATIA: Animate Constraint (ölçüyü oynat) + Sketch Positioning (düzlem değiştir)
  get modellemeAnimAktif(): boolean { return !!this.modelleme?.animasyonAktif; }
  modellemeAnimasyon(): void { this.modellemeAl().olcuAnimasyon(); this.cd.detectChanges(); }
  modellemeEskizDuzlem(tip: 'xy' | 'xz' | 'yz'): void { const ok = this.modellemeAl().eskizDuzlemeTasi(tip); this.bildirim.aracKullanildi(ok ? `Eskiz ${tip.toUpperCase()} düzlemine taşındı` : 'Aktif eskiz gerekli'); this.cd.detectChanges(); }
  private _dzCycle = 0;
  modellemeEskizDuzlemCycle(): void { const s = ['xy', 'xz', 'yz'] as const; this._dzCycle = (this._dzCycle + 1) % 3; this.modellemeEskizDuzlem(s[this._dzCycle]); }
  dofTooltip(d: any): string { return !d ? '' : d.durum === 'tam' ? 'Sketch tam (iso) tanımlı' : d.durum === 'asiri' ? 'Aşırı kısıtlı — bir kısıt kaldırın' : `${d.dof ?? d.serbest} serbestlik derecesi (kısıt/ölçü ekleyin)`; }
  get mdlProfilAktif(): boolean { return ['cizgi', 'polyline', 'dikdortgen', 'dikdortgenMerkez', 'cokgen', 'cember', 'cember3n', 'elips', 'yay', 'spline', 'slot', 'nokta', 'insacizgi', 'konik', 'sablonDik', 'sablonKeyhole', 'sablonParalel'].includes(this.modellemeAktifArac); }
  // Ürün ağacı: arama + sürükle-bırak yeniden sıralama
  agacArama = '';
  onTreeReorder(e: { kaynak: any, hedef: any }): void {
    if (this.modelleme?.ozellikSiralaTasi?.(e.kaynak, e.hedef)) { this.FikoYT.degisti.emit(); this.cd.detectChanges(); }
  }

  modellemeDikBak(): void { this.modelleme?.dikBak(); }
  modellemeGridToggle(): void { this.modelleme?.gridToggle(); this.modellemeGrid = !!this.modelleme?.gridGoster; this.cd.detectChanges(); }
  modellemeBitir(): void { this.modelleme?.projekte3dBitir(); this.modelleme?.kesitKaldir?.(); this.modelleme?.sketchBitir(); this.modellemeAktifArac = 'sec'; }
  modellemeIptal(): void { this.modelleme?.projekte3dBitir(); this.modelleme?.iptalSketch(); this.modellemeAktifArac = 'sec'; this.cd.detectChanges(); }

  // CATIA: 3D Yansıt (Project) — katı kenarını aktif eskize inşa çizgisi olarak izdüşür
  get modellemeProjekteAktif(): boolean { return !!this.modelleme?.projekteAktif; }
  modellemeProjekte3d(): void {
    if (this.modelleme?.projekteAktif) { this.modelleme.projekte3dBitir(); this.cd.detectChanges(); return; }
    const ok = this.modellemeAl().projekte3dBaslat();
    this.bildirim.aracKullanildi(ok ? '3D Yansıt: katı kenarına tıkla (inşa çizgisi olur)' : 'Önce aktif eskiz + katı gerekli');
    this.cd.detectChanges();
  }

  // CATIA: Intersect 3D Element — katı-düzlem kesişim eğrilerini eskize düşür (OCCT section)
  modellemeIntersect3d(): void {
    const n = this.modellemeAl().intersect3dUygula();
    if (n) this.bildirim.aracKullanildi(`${n} kesişim eğrisi eskize düştü`);
    this.cd.detectChanges();
  }

  // CATIA: Cut Part by Sketch Plane — eskiz düzlemiyle görsel kesit (clipping)
  get modellemeKesitAktif(): boolean { return !!this.modelleme?.kesitDurum; }
  modellemeKesit(): void { const a = this.modellemeAl().kesitToggle(); this.bildirim.aracKullanildi(a ? 'Kesit görünümü açık' : 'Kesit kapalı'); this.cd.detectChanges(); }
  modellemeKesitYon(): void { this.modelleme?.kesitYonToggle(); }
  modellemeMesgul = false;
  /** Ağır CSG işlemini UI'ı kilitlemeden çalıştır: önce "hesaplanıyor" çiz, sonra hesapla. */
  private mdlAgir(fn: () => boolean, basari: string, hata: string): void {
    if (this.modellemeMesgul) return;
    this.modellemeMesgul = true; this.cd.detectChanges();
    setTimeout(() => {
      let ok = false;
      try { ok = fn(); } catch (e) { console.warn('[Modelleme] işlem hatası', e); }
      this.modellemeMesgul = false;
      this.bildirim.aracKullanildi(ok ? basari : hata);
      this.cd.detectChanges();
    }, 30);
  }
  // CATIA tarzı komut penceresi (canlı önizleme + Tamam/İptal)
  mdlKomutAcik: IKomutTanim | null = null;
  /** Komut penceresini MEVCUT FikoDialogCore ile aç (tutarlı UI: neon, sürüklenebilir, dimmer'sız). */
  mdlKomutAc(komutId: string): void {
    const m = this.modellemeAl();
    if (komutId === 'yazi3d') m.yaziFontHazirla('helvetiker');
    const tanim = komutBul(komutId);
    if (!tanim) { this.bildirim.aracKullanildi('Komut tanımı bulunamadı: ' + komutId); return; }
    if (tanim.gerektirir === 'govde' && !m.govdeVar) { this.bildirim.aracKullanildi('Bu komut için önce bir katı/gövde oluştur (Kutu, Pad vb.)'); return; }
    this.DialogFiko.ac({
      bilesen: FikoKomutIcerik,
      ayarlar: { baslik: tanim.etiket, simgeResim: './simgeler/3d.webp', boyut: { w: 250, h: 'auto' } },   // sabit genişlik (boyutsuz → fit-content + resize-fill = dialog şişiyordu)
      parametreler: { tanim, yonetici: m },
      id: 'fikoKomutPenceresi',
    } as any);
  }
  modellemeYazi3D(): void { this.mdlKomutAc('yazi3d'); }
  mdlKomutKapat(): void { this.mdlKomutAcik = null; this.cd.detectChanges(); }

  /** Parametre Yönetimi dialogunu aç (merkezi parametreler — grup/formül/konfig/kontrol). */
  modellemeParametreler(): void {
    const m = this.modellemeAl();
    if (!m?.knowledge) { this.bildirim?.aracKullanildi?.('Parametre sistemi hazır değil'); return; }
    this.DialogFiko.ac({
      bilesen: FikoParametreWorkbenchComponent,
      id: 'fiko-parametre-yonetim',
      ayarlar: { baslik: 'Parametreler', simgeResim: './simgeler/3d.webp', modalMi: false, sinirlandi: false, boyut: { w: 680, h: 'auto' } },
      parametreler: { knowledge: m.knowledge }
    } as any);
  }

  /** f(x) formül editörünü ayrı dialogda aç. */
  fxDialogAc(paramId: string): void {
    const m = this.modelleme; if (!m?.knowledge) return;
    const id = 'fiko-fx-editor';
    this.DialogFiko.ac({
      bilesen: FikoFxEditorComponent,
      id,
      ayarlar: { baslik: 'Formül f(x)', simgeResim: './simgeler/3d.webp', modalMi: false, sinirlandi: false, boyut: { w: 300, h: 'auto' } },
      parametreler: { knowledge: m.knowledge, paramId, kapat: () => this.DialogFiko.idIleKapat(id) }
    } as any);
  }

  // CATIA: Pad/Pocket → ESKİ generic pencere İPTAL, direkt yeni Pad Definition penceresi (DialogCore)
  modellemePad(): void { this.modellemePadPocket('pad'); }
  modellemePocket(): void { this.modellemePadPocket('pocket'); }
  private modellemePadPocket(tip: 'pad' | 'pocket'): void {
    const ok = this.modellemeAl().padPocketBaslat(tip);
    if (!ok) this.bildirim.aracKullanildi('Önce kapalı bir profil çiz (aktif eskiz gerekli)');
    this.cd.detectChanges();
  }
  // CATIA: Shaft/Groove → ESKİ generic pencere İPTAL, direkt Shaft Definition penceresi
  modellemeShaft(): void { this.modellemeShaftGroove('shaft'); }
  modellemeGroove(): void { this.modellemeShaftGroove('groove'); }
  private modellemeShaftGroove(tip: 'shaft' | 'groove'): void {
    const ok = this.modellemeAl().shaftGrooveBaslat(tip);
    if (!ok) this.bildirim.aracKullanildi('Önce kapalı bir profil çiz (aktif eskiz gerekli)');
    this.cd.detectChanges();
  }
  // CATIA: Hole (Delik) → yüze tıkla, sketch'siz delik aç + Definition penceresi
  modellemeHole(): void {
    const ok = this.modellemeAl().holeBaslat();
    if (!ok) this.bildirim.aracKullanildi('Delik için önce bir katı oluştur');
    this.cd.detectChanges();
  }
  // CATIA Çoklu-Gövde + Boolean
  modellemeYeniGovde(): void { this.modellemeAl().yeniGovde(); this.bildirim.aracKullanildi('Yeni gövde aktif — modelle, sonra Boolean ile birleştir'); this.cd.detectChanges(); }
  modellemeBool(op: 'assemble' | 'add' | 'remove' | 'intersect'): void {
    const ok = this.modellemeAl().boolBaslat(op);
    if (!ok) this.bildirim.aracKullanildi('Önce "Yeni Gövde" ile 2. gövde oluşturup modelle');
    this.cd.detectChanges();
  }
  // GSD Yüzey (Surface)
  modellemeYuzey(tip: 'Extrude' | 'Revolve' | 'Fill' | 'Loft' | 'Sweep'): void { this.mdlKomutAc('yuzey' + tip); }
  modellemeThickSurface(): void {
    const ok = this.modellemeAl().thickSurfaceBaslat();
    if (!ok) this.bildirim.aracKullanildi('Önce bir yüzey oluştur (Yüzey Uzat/Dön/Dolgu)');
    this.cd.detectChanges();
  }
  modellemeYuzeyOffset(): void {
    const ok = this.modellemeAl().yuzeyOffsetSonBaslat();
    if (!ok) this.bildirim.aracKullanildi('Önce profil-tabanlı yüzey oluştur');
    this.cd.detectChanges();
  }
  modellemeSplitSurface(): void {
    const ok = this.modellemeAl().splitSurfaceBaslat();
    if (!ok) this.bildirim.aracKullanildi('Bir katı + Yüzey Uzat gerekli');
    this.cd.detectChanges();
  }
  // GSD Wireframe
  modellemeNokta3d(): void { this.modellemeAl().nokta3dEkle(); this.cd.detectChanges(); }
  modellemeCizgi3d(): void { this.modellemeAl().cizgi3dEkle(); this.cd.detectChanges(); }
  modellemeCember3d(): void { this.modellemeAl().cember3dEkle(); this.cd.detectChanges(); }
  modellemeSpline3d(): void { this.modellemeAl().spline3dEkle(); this.cd.detectChanges(); }
  modellemePolyline3d(): void { this.modellemeAl().polyline3dEkle(); this.cd.detectChanges(); }
  modellemeCurveSmooth(): void { this.modellemeAl().curveSmoothEkle(); this.cd.detectChanges(); }
  modellemeCorner(): void { this.modellemeAl().cornerEkle(); this.cd.detectChanges(); }
  modellemeIsoparametrik(): void { this.modellemeAl().isoparametrikEkle(); this.cd.detectChanges(); }
  modellemeCombine3d(): void { this.modellemeAl().combine3dEkle(); this.cd.detectChanges(); }
  modellemeEquationCurve(): void { this.modellemeAl().equationCurveEkle(); this.cd.detectChanges(); }
  modellemeSpine3d(): void { this.modellemeAl().spine3dEkle(); this.cd.detectChanges(); }
  modellemePipe3d(): void { this.modellemeAl().pipe3dEkle(); this.cd.detectChanges(); }
  modellemeHelix3d(): void { this.modellemeAl().helix3dEkle(); this.cd.detectChanges(); }
  modellemeDuzlem3d(): void { this.modellemeAl().duzlem3dEkle(); this.cd.detectChanges(); }
  modellemeSpiral3d(): void { this.modellemeAl().spiral3dEkle(); this.cd.detectChanges(); }
  modellemeParalelEgri(): void { this.modellemeAl().paralelEgri3dEkle(); this.cd.detectChanges(); }
  modellemeConnectEgri(): void { this.modellemeAl().connectEgri3dEkle(); this.cd.detectChanges(); }
  modellemeYuzeyKenar(): void { this.modellemeAl().yuzeyKenar3dEkle(); this.cd.detectChanges(); }
  modellemeConic3d(): void { this.modellemeAl().conic3dEkle(); this.cd.detectChanges(); }
  modellemeYuzeyJoin(): void { this.modellemeAl().yuzeyJoinEkle(); this.cd.detectChanges(); }
  modellemeKesisim(): void { this.modellemeAl().kesisim3dEkle(); this.cd.detectChanges(); }
  modellemeYuzeyTrim(): void { this.modellemeAl().yuzeyTrimEkle(); this.cd.detectChanges(); }
  modellemeYuzeyExtract(): void { this.modellemeAl().yuzeyExtractEkle(); this.cd.detectChanges(); }
  modellemeYuzeyBlend(): void { this.modellemeAl().yuzeyBlendEkle(); this.cd.detectChanges(); }
  modellemeYuzeyExtrapolate(): void { this.modellemeAl().yuzeyExtrapolateEkle(); this.cd.detectChanges(); }
  modellemeGorunum(mod: 'dolu' | 'tel' | 'seffaf'): void { if (mod === 'seffaf') this.komutKampanya('GORUNTULEME', 'xray', 'X-Ray / Şeffaf Mod'); this.modellemeAl().sahneGorunumModu(mod); this.cd.detectChanges(); }
  modellemeRib(): void { this.mdlKomutAc('rib'); }
  modellemeShell(): void { this.mdlKomutAc('shell'); }
  modellemeDraft(): void { this.mdlKomutAc('draft'); }
  /** KUSURSUZ STEP/STP içe aktar — dosya seçici → gerçek B-Rep gövde → üstüne pocket/fillet/shell. */
  modellemeStepKusursuz(): void {
    this.komutKampanya('GORUNTULEME', '', 'STP/STEP İçe Aktarma (Görüntüleme bazına dahil)');
    const inp = document.createElement('input');
    inp.type = 'file'; inp.accept = '.step,.stp,.STEP,.STP';
    inp.onchange = async () => {
      const dosya = inp.files?.[0]; if (!dosya) return;
      this.bildirim.aracKullanildi('STEP okunuyor (kusursuz B-Rep kernel)…');
      try {
        const bytes = new Uint8Array(await dosya.arrayBuffer());
        const ok = await this.modellemeAl().disStepAl(bytes);
        this.bildirim.aracKullanildi(ok ? 'STEP KUSURSUZ içe aktarıldı — pocket/fillet/shell uygulayabilirsiniz' : 'STEP okunamadı');
      } catch (e) { console.warn('[Modelleme] STEP import hatası', e); this.bildirim.aracKullanildi('STEP içe aktarma hatası'); }
      this.cd.detectChanges();
    };
    inp.click();
  }
  /** CATIA 3D Accuracy: görüntü mesh kalitesi (B-Rep korunur, sadece tessellation yenilenir). */
  mdlMeshKalite(sev: 'kaba' | 'orta' | 'ince' | 'cokInce'): void {
    const ok = (this.modellemeAl() as any)?.displayKaliteAyarla?.(sev);
    this.motorBildir(ok ? ('Görüntü kalitesi: ' + sev) : 'Önce B-Rep gövde gerekli');   // in-app toast (ntfy değil)
    this.cd.detectChanges();
  }
  /** CATIA otomatik delik tanıma: gövde B-Rep dikey silindirik yüzlerden delik adayları (dünya koordinatı). */
  private camDelikAdaylari(): { x: number; y: number; z: number; cap: number; derinlik: number }[] {
    const m: any = this.modelleme;
    const mesh: any = m?.govdeMesh;
    if (!mesh?.geometry) return [];
    const fg: any[] = mesh.occt_faceGroups || [];
    if (!fg.length) return [];
    const geo = mesh.geometry;
    const pos = geo.attributes?.['position'];
    const grupAttr = geo.attributes?.['grup'];
    if (!pos || !grupAttr) return [];
    // faceId → local Z aralığı (delik derinliği için)
    const zRange = new Map<number, { min: number; max: number }>();
    for (let v = 0; v < pos.count; v++) {
      const fid = grupAttr.getZ(v); const z = pos.getZ(v);
      const e = zRange.get(fid);
      if (!e) zRange.set(fid, { min: z, max: z });
      else { if (z < e.min) e.min = z; if (z > e.max) e.max = z; }
    }
    mesh.updateMatrixWorld?.(true);
    const sonuc: { x: number; y: number; z: number; cap: number; derinlik: number }[] = [];
    const tmp = new THREE.Vector3();
    for (let i = 0; i < fg.length; i++) {
      const g = fg[i];
      if (g?.surfaceType !== 'CYLINDER' || !g.surfaceData) continue;
      const sd = g.surfaceData; const c = sd.center, ax = sd.axis, r = sd.radius;
      if (!c || !ax || !(r > 0) || r > 50) continue;   // makul delik yarıçapı
      if (Math.abs(tmp.set(ax.x, ax.y, ax.z).normalize().z) < 0.85) continue;   // 3-axis: sadece ~dikey delikler
      const zr = zRange.get(i) ?? zRange.get(g.faceId);
      const zmax = zr ? zr.max : c.z;
      const derinlik = zr ? (zr.max - zr.min) : 10;
      const w = new THREE.Vector3(c.x, c.y, zmax).applyMatrix4(mesh.matrixWorld);
      sonuc.push({ x: w.x, y: w.y, z: w.z, cap: r * 2, derinlik: Math.max(1, derinlik) });
    }
    return sonuc;
  }
  /** CAM gövde referansı: modelleme B-Rep gövdesi → yoksa seçili/yüklenen parça mesh'i (STEP/mesh import). CAM bu mesh'ten kontur/yüz seçer. */
  private camGovdeMeshBul(): THREE.Mesh | null {
    const gm = (this.modelleme as any)?.govdeMesh;
    if (gm) return gm;
    const sahne: any = this.fikoThreejs?.sahneler?.[0];
    if (!sahne) return null;
    // önce kullanıcının 3D'de seçtiği mesh (faceId/grup attribute'lu)
    const secili = sahne.secimler?.seciliMeshler || sahne.secililer?.seciliMeshler;
    if (Array.isArray(secili)) { for (const o of secili) if (o?.isMesh && o.geometry?.attributes?.['grup']) return o; }
    // yoksa: sahnedeki en büyük görünür grup-attribute'lu mesh (yüklenen parça)
    let best: THREE.Mesh | null = null, bestTri = 0;
    sahne.traverse?.((o: any) => {
      if (o.isMesh && o.visible && o.geometry?.attributes?.['grup']) {
        const tri = o.geometry.index ? o.geometry.index.count / 3 : (o.geometry.attributes['position']?.count || 0) / 3;
        if (tri > bestTri && tri > 20) { bestTri = tri; best = o; }   // eksen/gizmo (≤10 tri) hariç
      }
    });
    return best;
  }
  /** CATIA associative tool axis: faceId'nin güncel B-Rep yüz normali (dünya). Parça değişince güncel normal döner. */
  private camYuzNormal(faceId: number): { x: number; y: number; z: number } | null {
    const m: any = this.modelleme; const mesh: any = m?.govdeMesh;
    if (!mesh || faceId == null) return null;
    const fg = mesh.occt_faceGroups?.[faceId];
    if (!fg?.normal) return null;
    mesh.updateMatrixWorld?.(true);
    const nm = new THREE.Matrix3().getNormalMatrix(mesh.matrixWorld);
    const n = new THREE.Vector3(fg.normal.x, fg.normal.y, fg.normal.z).applyMatrix3(nm).normalize();
    return { x: n.x, y: n.y, z: n.z };
  }
  /** CATIA associatif düzlem: faceId → o yüzün LOCAL Z'si (occt_faceGroups center; yoksa grup attr'dan ortalama). CAM gövdesiyle aynı mesh. */
  private camYuzZ(faceId: number): number | null {
    const mesh: any = this.camGovdeMeshBul(); if (!mesh || faceId == null) return null;
    const fg = mesh.occt_faceGroups?.[faceId];
    if (fg?.center?.z != null) return Math.round(fg.center.z * 1000) / 1000;
    // fallback: grup attribute'dan yüzün ortalama Z'si (local)
    const geo = mesh.geometry; const grup = geo?.attributes?.['grup']; const pos = geo?.attributes?.['position'];
    if (!grup || !pos) return null;
    let s = 0, n = 0; for (let i = 0; i < grup.count; i++) if (grup.getZ(i) === faceId) { s += pos.getZ(i); n++; }
    return n ? Math.round((s / n) * 1000) / 1000 : null;
  }
  /** CAM: otomatik delik tanıma → matkap operasyonları oluştur. */
  camDelikBul(): void {
    if (!this.cam) { this.bildirim.aracKullanildi('Önce CAM modunu aç'); return; }
    this.cam.delikleriOtomatikBul();
    this.cd.detectChanges();
  }
  get mdlAktifKalite(): string { return (this.modelleme as any)?.displayKaliteOran != null ? 'ozel' : ((this.modelleme as any)?.displayKaliteSeviye || 'orta'); }
  /** Aktif sayısal kalite oranı (slider değeri). */
  get mdlKaliteOran(): number {
    const m: any = this.modelleme;
    if (m?.displayKaliteOran != null) return m.displayKaliteOran;
    return m?.displayKalite?.oran ?? 0.004;
  }
  /** CATIA 3D Accuracy: sayısal oran ile mesh kalitesi (slider). Küçük=hassas. */
  mdlMeshKaliteSayisal(oran: number | string): void {
    const o = typeof oran === 'string' ? parseFloat(oran) : oran;
    const ok = (this.modellemeAl() as any)?.displayKaliteSayisalAyarla?.(o);
    if (ok) this.motorBildir('3D Hassasiyet: ' + o.toFixed(4) + ' mm');   // slider → in-app toast (ntfy spam DEĞİL)
    this.cd.detectChanges();
  }
  /** CATIA Dynamic Section: düzlemle GERÇEK B-Rep kesit profili (FikoDinamikKesit kullanır — analitik kenarlar). B-Rep yoksa null. */
  brepKesitProfili(origin: { x: number; y: number; z: number }, normal: { x: number; y: number; z: number }): any[] | null {
    const md: any = this.modelleme; return md?.brepVarMi?.() ? (md.kesitProfiliBrep?.(origin, normal) || null) : null;
  }

  /** GERÇEK B-Rep kernel (OpenCascade.js) — kusursuz fillet. İlk çağrı OCCT yükler (~3-8sn). */
  async modellemeOCCTKutuFillet(): Promise<void> {
    this.bildirim.aracKullanildi('OCCT kernel (kusursuz B-Rep) yükleniyor…');
    const ok = await this.modellemeAl().occtKutuFillet(40, 40, 40, 6);
    this.bildirim.aracKullanildi(ok ? 'OCCT KUSURSUZ fillet kutu oluştu (gerçek B-Rep)' : 'OCCT başarısız');
    this.cd.detectChanges();
  }
  /** Kernel modu: Mesh-CSG (hızlı) ↔ OCCT (kusursuz B-Rep). Mevcut model korunur, yeniden hesaplanır. */
  get occtModuAktif(): boolean { return this.modelleme?.occtModuAktif || false; }
  async modellemeOCCTModu(): Promise<void> {
    const acik0 = this.occtModuAktif;
    if (!acik0) this.bildirim.aracKullanildi('OCCT kernel (kusursuz B-Rep) yükleniyor…');
    const acik = await this.modellemeAl().occtModuToggle();
    this.bildirim.aracKullanildi(acik ? 'KUSURSUZ kernel AKTİF (OpenCascade B-Rep)' : 'Hızlı kernel (Mesh-CSG)');
    this.cd.detectChanges();
  }
  get modellemeDurumOzeti(): any { return this.modelleme?.sketchDurumOzeti || null; }
  get modellemeHedefVar(): boolean { return !!this.modelleme?.hedefVar; }
  get modellemeGovdeVar(): boolean { return !!this.modelleme?.govdeVar; }
  modellemeGeometriSeti(): void { this.modellemeAl().geometriSetiEkle(); this.bildirim.aracKullanildi('Geometrik Set eklendi'); }
  modellemeBodyEkle(): void { const b = this.modellemeAl().bodyEkle(); this.bildirim.aracKullanildi('Yeni Body eklendi ve aktif yapıldı — sonraki özellikler buraya gelecek'); this.cd.detectChanges(); }
  get modellemeGovdeBilgi(): any { return this.modelleme?.govdeBilgi || null; }
  get modellemeAgirlikStr(): string { const g = this.modelleme?.govdeBilgi; if (!g) return ''; return g.agirlikG >= 1000 ? (g.agirlikG / 1000).toFixed(2) + ' kg' : g.agirlikG.toFixed(0) + ' g'; }

  // CATIA-tarzı workbench: sketch modunda otomatik 'sketcher', aksi halde seçilen workbench
  readonly modellemeWorkbenchler = [
    { id: 'part', ad: 'Part Design', ikon: 'cube', renk: '#22d3ee' },
    { id: 'surface', ad: 'Surface (GSD)', ikon: 'wpforms', renk: '#2dd4bf' },
    { id: 'sketcher', ad: 'Sketcher', ikon: 'pencil alternate', renk: '#34d399' },
    { id: 'tesisat', ad: 'Tesisat', ikon: 'grip lines', renk: '#f59e0b' },
    { id: 'taki', ad: 'Takı', ikon: 'gem', renk: '#e879f9' },
    { id: 'insaat', ad: 'Mimarlık', ikon: 'building', renk: '#60a5fa' },
    { id: 'celik', ad: 'Çelik', ikon: 'indent', renk: '#94a3b8' },
    { id: 'marangoz', ad: 'Marangoz', ikon: 'tree', renk: '#b08968' },
    { id: 'cam', ad: 'CAM', ikon: 'cogs', renk: '#ff6b6b' },
    { id: '2dcam', ad: '2D CAM', ikon: 'wrench', renk: '#fbbf24' },
    { id: 'analiz', ad: 'Analiz', ikon: 'chart area', renk: '#f472b6' },
  ];
  workbenchAcik = false;
  wbMenuPos = { x: 60, y: 200 };           // kök seviye menü konumu (overflow'dan kaçar)
  // Ribbon komut flyout'u — ilgili komutları tek buton altında toplar (ribbon kalabalığını önler)
  ribbonFlyout: { ad: string; x: number; y: number; ogeler: { ad: string; ikon: string; fn: () => void }[] } | null = null;
  private ribbonFlyoutListe(ad: string): { ad: string; ikon: string; fn: () => void }[] {
    const L: Record<string, { ad: string; ikon: string; fn: () => void }[]> = {
      egri: [
        { ad: 'Çizgi', ikon: 'minus', fn: () => this.modellemeCizgi3d() },
        { ad: 'Çember', ikon: 'circle outline', fn: () => this.modellemeCember3d() },
        { ad: 'Spline', ikon: 'wpforms', fn: () => this.modellemeSpline3d() },
        { ad: 'Polyline (Düz Segment)', ikon: 'share alternate', fn: () => this.modellemePolyline3d() },
        { ad: 'Helis', ikon: 'dna', fn: () => this.modellemeHelix3d() },
        { ad: 'Spiral', ikon: 'spinner', fn: () => this.modellemeSpiral3d() },
        { ad: 'Paralel Eğri', ikon: 'equals', fn: () => this.modellemeParalelEgri() },
        { ad: 'Bağlantı Eğrisi', ikon: 'share', fn: () => this.modellemeConnectEgri() },
        { ad: 'Konik (Parabol/Elips/Hiperbol)', ikon: 'circle notch', fn: () => this.modellemeConic3d() },
        { ad: 'Köşe (Corner)', ikon: 'circle notch', fn: () => this.modellemeCorner() },
        { ad: 'Eğri Yumuşat (Smooth)', ikon: 'magic', fn: () => this.modellemeCurveSmooth() },
        { ad: 'Iso Eğri (Isoparametric)', ikon: 'grid layout', fn: () => this.modellemeIsoparametrik() },
        { ad: 'Birleştir (Combine)', ikon: 'sitemap', fn: () => this.modellemeCombine3d() },
        { ad: 'Denklem Eğrisi f(t)', ikon: 'calculator', fn: () => this.modellemeEquationCurve() },
        { ad: 'Omurga (Spine)', ikon: 'level up alternate', fn: () => this.modellemeSpine3d() },
        { ad: 'Boru (Eğri Boyunca Pipe)', ikon: 'grip lines', fn: () => this.modellemePipe3d() },
      ],
      yuzeyislem: [
        { ad: 'Paralel Yüzey (Offset)', ikon: 'clone outline', fn: () => this.modellemeYuzeyOffset() },
        { ad: 'Kalınlaştır (Katıya Çevir)', ikon: 'clone', fn: () => this.modellemeThickSurface() },
        { ad: 'Yüzeyle Böl', ikon: 'cut', fn: () => this.modellemeSplitSurface() },
        { ad: 'Yüzey Sınırı (Boundary)', ikon: 'dot circle outline', fn: () => this.modellemeYuzeyKenar() },
        { ad: 'Birleştir (Join/Sew)', ikon: 'object group', fn: () => this.modellemeYuzeyJoin() },
        { ad: 'Kesişim Eğrisi (Intersection)', ikon: 'crosshairs', fn: () => this.modellemeKesisim() },
        { ad: 'Kırp (Trim)', ikon: 'crop', fn: () => this.modellemeYuzeyTrim() },
        { ad: 'Yüzey Çıkar (Extract)', ikon: 'expand', fn: () => this.modellemeYuzeyExtract() },
        { ad: 'Blend (İki Eğri Arası Yüzey)', ikon: 'grav', fn: () => this.modellemeYuzeyBlend() },
        { ad: 'Uzat (Extrapolate)', ikon: 'expand arrows alternate', fn: () => this.modellemeYuzeyExtrapolate() },
      ],
      gorunum: [
        { ad: 'Dolu (Shaded)', ikon: 'square full', fn: () => this.modellemeGorunum('dolu') },
        { ad: 'Tel Kafes (Wireframe)', ikon: 'th', fn: () => this.modellemeGorunum('tel') },
        { ad: 'Yarı Saydam (X-Ray)', ikon: 'adjust', fn: () => this.modellemeGorunum('seffaf') },
      ],
    };
    return L[ad] || [];
  }
  ribbonFlyoutToggle(ad: string, ev: MouseEvent): void {
    if (this.ribbonFlyout?.ad === ad) { this.ribbonFlyout = null; this.cd.detectChanges(); return; }
    const b = (ev.currentTarget as HTMLElement)?.getBoundingClientRect();
    this.ribbonFlyout = { ad, x: Math.round(b?.left || 100), y: Math.round((b?.top || 200) - 6), ogeler: this.ribbonFlyoutListe(ad) };
    this.cd.detectChanges();
  }
  ribbonFlyoutSec(o: { fn: () => void }): void { this.ribbonFlyout = null; o.fn?.(); this.cd.detectChanges(); }
  private mdlSecilenWB: string = 'part';   // sketch dışı manuel seçim
  get modellemeWorkbench(): string { return this.modellemeDurum === 'sketch' ? 'sketcher' : this.mdlSecilenWB; }
  get modellemeWorkbenchBilgi(): any { return this.modellemeWorkbenchler.find(w => w.id === this.modellemeWorkbench) || this.modellemeWorkbenchler[0]; }
  // Aktif workbench'in makro komutları (ribbon, veri-odaklı)
  get modellemeMakroKomutlar(): IKomutTanim[] { return FIKO_KOMUTLAR.filter(k => k.workbench === this.modellemeWorkbench); }
  workbenchToggle(ev?: MouseEvent): void {
    this.workbenchAcik = !this.workbenchAcik;
    if (this.workbenchAcik && ev) {
      const b = (ev.currentTarget as HTMLElement)?.getBoundingClientRect();
      if (b) this.wbMenuPos = { x: Math.round(b.left), y: Math.round(b.top - 6) };   // rozetin üstünde
    }
    this.cd.detectChanges();
  }
  workbenchSec(id: string): void {
    this.workbenchAcik = false;
    if (id === 'sketcher') {
      if (this.modellemeDurum !== 'sketch') this.bildirim.aracKullanildi('Sketcher için bir düzlem (XY/XZ/YZ) ya da yüz seçin');
    } else {
      if (this.modellemeDurum === 'sketch') this.modellemeBitir();
      this.mdlSecilenWB = id;
      if (id === 'cam') this.bildirim.aracKullanildi('CAM: alttan 2D işleme (Profil/Cep/Delik/Gravür) veya 3D Frezeleme (Kaba/Parallel/Waterline) seçin');   // dialog AÇMA — ribbon yeterli
      if (id === '2dcam') { if (!this.camAcik) this.camToggle(); this.camTakimleriniKur(); }   // yeni CATIA Prismatic Machining paneli + takım kaynağı ağacı
      else if (this.camAcik) { this.camAcik = false; this.cam?.replayDurdur(); this.cam?.camSecimBitir(); this.cam?.gorselTemizle(); this.cam3dStokTemizle(); }   // başka WB'ye geçince CAM panelini + seçim/makro + saydam stok kapat
    }
    this.cd.detectChanges();
  }
  /** CAM workbench komutu: 2D CAM panelini açar (verilen aktivite tipiyle). */
  camAktivite(tip: 'profil' | 'cep' | 'delik' | 'gravur' | 'gcode'): void {
    this.ac2DCamDialog(tip);
  }
  /** 3D CAM operasyonu: gövde mesh üzerinde gerçek toolpath + G-code (parallel/roughing/waterline/pencil). */
  cam3dOp(op: 'parallel' | 'roughing' | 'waterline' | 'pencil'): void {
    const m = this.modellemeAl();
    if (!m.govdeVar) { this.bildirim.aracKullanildi('Önce bir gövde (katı) oluşturun'); return; }
    const param: any = {
      takim: op === 'roughing' ? { tip: 'duz', cap: 10 } : { tip: 'kure', cap: 6 },
      feeds: { devir: 10000, ilerleme: 1500, dalma: 400, rapid: 5000 },
      guvenliZ: 120, scallop: 0.08, zigzag: true, eksen: 'x',
      stepdown: op === 'roughing' ? 5 : 3, stockLeave: op === 'roughing' ? 0.3 : 0,
    };
    this.cam3dSonParam = param;
    try {
      const meta = m.cam3dCalistir(op, param);
      if (meta) this.bildirim.aracKullanildi(meta.operasyon + ': ' + meta.nokta + ' nokta · ' + meta.toplamMesafe + ' mm · ~' + meta.sureDk + ' dk');
      else this.bildirim.aracKullanildi('3D CAM toolpath üretilemedi');
    } catch (e) {
      console.warn('[CAM] 3D CAM hatası:', e);
      this.bildirim.aracKullanildi('3D CAM işleme hatası — modeli kontrol edin');
    }
    this.cd.detectChanges();
  }
  private cam3dSonParam: any = null;
  /** Son 3D CAM toolpath'i G-code (.nc) olarak indir. */
  cam3dGcodeIndir(): void {
    const m = this.modellemeAl(); if (!this.cam3dSonParam) { this.bildirim.aracKullanildi('Önce bir 3D CAM operasyonu çalıştırın'); return; }
    const g = m.cam3dGcode(this.cam3dSonParam); if (!g) return;
    const blob = new Blob([g], { type: 'text/plain' }); const url = URL.createObjectURL(blob);
    const a = document.createElement('a'); a.href = url; a.download = 'fikoyt-cam3d.nc'; a.click(); URL.revokeObjectURL(url);
    this.bildirim.aracKullanildi('G-code indirildi (fikoyt-cam3d.nc)');
  }
  private cam3dStokGrup: any = null;
  private cam3dStokTemizle(): void {
    if (this.cam3dStokGrup) { this.cam3dStokGrup.parent?.remove(this.cam3dStokGrup); this.cam3dStokGrup.traverse((o: any) => { o.geometry?.dispose?.(); o.material?.dispose?.(); }); this.cam3dStokGrup = null; }
  }
  cam3dTemizle(): void { this.modellemeAl().cam3dYolTemizle(); this.cam3dStokTemizle(); this.fikoThreejs.ciz?.(); }
  /** Son 3D CAM toolpath'ini KÜTÜK SİMÜLASYONU'nda aç — GERÇEK ürün ağacı node'u (Fikoperasyon→Nc Program→FikoTakımYolu). */
  cam3dSimulasyonAc(): void {
    const node = this.modellemeAl().cam3dYolNode;   // gerçek FikoTakımYoluv1 (Fikoperasyon altında → İşleme Ekseni doğal gelir)
    if (!node || !node.noktalar?.length) { this.bildirim.aracKullanildi('Önce bir 3D CAM operasyonu onaylayın (Parallel/Kaba/Waterline)'); return; }
    const sahne = this.fikoThreejs?.sahneler?.[0];
    // OTOMATİK STOK KÜTÜĞü (type=FikoKutuk → kutukOtomatikBul sahne taramasında bulur)
    this.cam3dStokTemizle();
    const gm = this.modellemeAl().govdeMeshRef;
    if (gm && sahne) {
      gm.geometry.computeBoundingBox(); const bb = gm.geometry.boundingBox!;
      const pay = 3, ustPay = 2, sx = (bb.max.x - bb.min.x) + pay * 2, sy = (bb.max.y - bb.min.y) + pay * 2, sz = (bb.max.z - bb.min.z) + pay + ustPay;
      const stokGeo = new THREE.BoxGeometry(sx, sy, sz);
      stokGeo.translate((bb.max.x + bb.min.x) / 2, (bb.max.y + bb.min.y) / 2, (bb.max.z + bb.min.z) / 2 + (ustPay - pay) / 2);
      const stokMesh = new THREE.Mesh(stokGeo, new THREE.MeshStandardMaterial({ color: 0xc7a35a, metalness: 0.1, roughness: 0.85, transparent: true, opacity: 0.55 }));
      stokMesh.name = 'cam3dStok'; stokMesh.visible = false;   // ham stok başlangıçta GÖRÜNMEZ — FikoSimilasyonV1 devralınca opak gösterir
      const ic = new THREE.Group(); ic.add(stokMesh);
      const stokGrup: any = new THREE.Group(); stokGrup.type = 'FikoKutuk'; stokGrup.add(ic); stokGrup.roughStockResult = { stock: ic };
      (sahne as any).add(stokGrup);
      this.cam3dStokGrup = stokGrup; this.fikoThreejs.ciz?.();
    }
    this.bildirim.aracKullanildi('Kütük simülasyonu açılıyor (' + node.noktalar.length + ' nokta)…');
    this.DialogFiko.ac({
      bilesen: FikoSimilasyonV1Component,
      id: 'fiko-cam3d-similasyon',
      ayarlar: { baslik: '3D CAM Kütük Simülasyonu', simgeResim: '/simgeler/logo.webp', modalMi: false, sinirlandi: false, boyut: { w: 360, h: 'auto' } },
      parametreler: { anaNesne: node },
    });
  }
  modellemeAynalaGovde(tip: 'xy' | 'xz' | 'yz'): void { this.mdlAgir(() => !!this.modellemeAl().aynalaGovde(tip), 'Aynalandı (' + tip.toUpperCase() + ')', 'Aynalama için gövde gerekli'); }
  modellemePatternDik(): void { this.mdlKomutAc('patternDik'); }
  modellemePatternDairesel(): void { this.mdlKomutAc('patternDairesel'); }
  modellemePatternIzgara(): void { this.mdlKomutAc('patternIzgara'); }

  /**
   * NPR Render modunu değiştirir (PBR, Gooch, Toon, Hatching, Silhouette)
   * @param mod Aktif edilecek NPR modu
   */
  degistirNPRModu(mod: NPRMod): void {
    if (mod && mod !== 'kapali' as any) this.komutKampanya('GORUNTULEME', 'render', 'Render Modları (NPR/Toon)');
    if (!this.fikoThreejs?.sahneler?.[0]) {
      // console.warn('Sahne hazır değil, NPR mod değişimi yapılamıyor.');
      return;
    }
    this.nprRenderer.modDegistir(mod, this.fikoThreejs.sahneler[0] as THREE.Scene);
    this.aktifNPRMod = mod;
    this.cd.detectChanges(); // UI'ı güncelle
    this.fikoThreejs.ciz(); // Sahneyi yeniden çiz
    this.bildirim.aracKullanildi(`NPR Modu: ${mod}`);
  }


  override ngAfterViewInit(): void {
    super.ngAfterViewInit();
    this.fikoThreejs.hazirla();

    /** BİLGİ: STP Görüntüleyici sahnesini başlat */
    let sahneStepViewer: SahneStepViewer = new SahneStepViewer(this.fikoThreejs);
    this.fikoThreejs.sahneler.push(sahneStepViewer);

    // 🎯 KAYDET/YÜKLE FIX (KRİTİK): FikoImporter kaydedilen modellemeyi geri yüklerken
    // `sahne.anaGosterim.modellemeDeserialize`'ı arar; bu metod ise sadece BU component'te.
    // Köprü kurmazsak yükleyici bulamaz → kaydedilen Part Design modeli geri GELMEZ.
    // Hem rendering anaGosterim'e (fikoThreejs) hem sahneStepViewer'a bağla (hangisini ararsa).
    const _modelDeser = (data: any, buffers?: Uint8Array[]) => this.modellemeDeserialize(data, buffers);
    (this.fikoThreejs as any).modellemeDeserialize = _modelDeser;
    (sahneStepViewer as any).modellemeDeserialize = _modelDeser;
    const _olcuDeser = (kayitlar: any[]) => this.olcumDeserialize(kayitlar);
    (this.fikoThreejs as any).olcumDeserialize = _olcuDeser;
    (sahneStepViewer as any).olcumDeserialize = _olcuDeser;

    /** ÖNEMLİ: On-demand render modu - User interaction'da tetiklenir */
    this.fikoThreejs.ciz();

    this.cd.detectChanges();

    // Site açıldığında bildirim gönder
    this.bildirim.siteAcildi();

    // YENİ: window.dosya kontrolü - StepAnalyzer'dan gelen dosyayı otomatik yükle
    this.okuPencereDosya();

    // PDF Editor için BroadcastChannel host'unu başlat
    this.initPdfChannelHost();

    // 🌳 TREE SYNC: Tree state değişikliklerini dinle ve UI'ı güncelle
    this.initTreeStateSync();

    // 📦 Uzun-bas hızlı menüsünden / sekmeden gelen Parça Takip isteğini dinle (lib→app decoupled)
    this._parcaTakipListener = () => this.parcaTakipAc();
    window.addEventListener('fiko:parca-takip', this._parcaTakipListener);

    // 🌌 Kart içeriğinden 3D yükle: @Input() localDosya (paylaş kutusu, upload öncesi) > @Input() dosyaId (gömülü mod) > ?dosya_id=XXX query param'u
    if (this.localDosya) {
      setTimeout(() => this.yerelDosyaYukle(this.localDosya!), 100);
    }
    const dosyaId = !this.localDosya && (this.dosyaId || this.route?.snapshot?.queryParamMap?.get('dosya_id'));
    if (dosyaId) {
      // Sahne hazır olduktan sonra yükle (ngAfterViewInit henüz sahne hazırlanmadan önce çalışıyor olabilir)
      setTimeout(() => this.dosyaYukle(dosyaId), 100);
    }

    // 🖼️ "Resimden 3D" sonucu yeni sekmede açıldıysa: ?fikoAi3D=<anahtar> → yerel kasadan yükle
    const ai3dAnahtar = this.route?.snapshot?.queryParamMap?.get('fikoAi3D');
    if (ai3dAnahtar) {
      setTimeout(() => this.ai3DKasadanYukle(ai3dAnahtar), 100);
    }
  }

  /**
   * 🖼️ "Resimden 3D" ile üretilip yerel kasaya (IndexedDB) konmuş modeli sahneye yükler.
   * Sunucuya yükleme yapılmaz; blob sadece bu tarayıcıda durur ve 1 gün sonra silinir.
   */
  private async ai3DKasadanYukle(anahtar: string): Promise<void> {
    try {
      if (!this.fikoThreejs?.sahneler?.[0]) {
        setTimeout(() => this.ai3DKasadanYukle(anahtar), 500);
        return;
      }
      const kasa = await import('../IFikoThreeJS/fiko-ai-3d/fiko-ai-3d-kasa');
      const kayit = await kasa.fikoAi3DKasadanAl(anahtar);
      if (!kayit) {
        this.motorBildir('Model bulunamadı (süresi dolmuş ya da başka tarayıcıda üretilmiş olabilir)');
        return;
      }
      const yukleyici = await import('../IFikoThreeJS/fiko-ai-3d/fiko-ai-3d-yukleyici');
      await yukleyici.fikoAi3DSahneyeEkle(
        this.fikoThreejs, kayit.blob, kayit.ad, kayit.hedefBoyutMm || 100
      );
      this.motorBildir('Model yüklendi: ' + kayit.ad);
    } catch (err) {
      console.warn('[Fiko3D] Resimden 3D modeli yüklenemedi:', err);
      this.motorBildir('Model yüklenemedi');
    }
  }
  private _parcaTakipListener: (() => void) | null = null;

  /**
   * 🌳 TREE SYNC: FikoSecililer'ın treeStateChanged event'ine subscribe ol
   * State değiştiğinde OnPush stratejisi için manuel change detection tetikle
   */
  private initTreeStateSync(): void {
    // Sahne ve secimler hazır olduktan sonra subscribe ol
    setTimeout(() => {
      const secimler = this.fikoThreejs?.sahneler?.[0]?.secimler;
      if (secimler?.treeStateChanged) {
        this.treeStateSubscription = secimler.treeStateChanged.subscribe(() => {
          // OnPush stratejisi nedeniyle manuel change detection gerekli
          this.cd.detectChanges();
          // 🎯 TREE SYNC FIX: agac-item detached olduğu için FikoYT.degisti emit et
          // Bu sayede agac-item component'leri kendi CD.detectChanges() çağırır
          this.FikoYT.degisti.emit();
        });
      }
    }, 100);
  }

  /**
   * PDF Editor için BroadcastChannel host'unu başlatır
   * Editor tarafından gelen isteklere cevap verir
   */
  private initPdfChannelHost(): void {
    this.pdfChannelHost = new FikoPdfChannelHost();

    // Screenshot isteği handler'ı - FikoScreenshot servisini kullan
    this.pdfChannelHost.onScreenshotRequest = async (request) => {
      console.log('[FikoPdfChannelHost] Screenshot isteği alındı:', request);

      const renderer = this.fikoThreejs?.sunucu;
      const scene = this.fikoThreejs?.sahneler?.[0];
      const camera = this.fikoThreejs?.aktifKamera;
      const kontrol = this.fikoThreejs?.aktifKontrol;

      if (!renderer || !scene || !camera) {
        console.error('[FikoPdfChannelHost] Eksik bileşenler:', { renderer: !!renderer, scene: !!scene, camera: !!camera });
        throw new Error('Renderer, scene veya kamera bulunamadı');
      }

      // Orijinal kamera pozisyonunu kaydet
      const originalPosition = camera.position.clone();
      const originalTarget = kontrol?.target?.clone() || new THREE.Vector3(0, 0, 0);

      // Görünüm moduna göre kamera pozisyonunu ayarla
      const view = request.view || 'current';
      if (view !== 'current') {
        this.setCameraView(camera, scene as any, kontrol, view);
      }

      // FikoScreenshot servisini kullan
      const screenshotService = new FikoScreenshot(renderer, scene as any, camera);

      const result = await screenshotService.capture({
        format: request.format === 'jpeg' ? 'jpeg' : 'png',
        scale: (request.scale || 2) as 1 | 2 | 4,
        transparent: request.transparent || false,
        includeAnnotations: true,
        quality: 0.95
      });

      // Kamerayı orijinal pozisyonuna geri döndür
      if (view !== 'current') {
        camera.position.copy(originalPosition);
        if (kontrol?.target) {
          kontrol.target.copy(originalTarget);
        }
        camera.lookAt(originalTarget);
        if (kontrol?.update) {
          kontrol.update();
        }
      }

      console.log('[FikoPdfChannelHost] Screenshot alındı:', { view, width: result.width, height: result.height });

      return {
        dataUrl: result.dataUrl,
        width: result.width,
        height: result.height
      };
    };

    // Ölçüm listesi isteği handler'ı
    this.pdfChannelHost.onMeasurementsRequest = () => {
      // FikoOlcum'dan ölçümleri al (varsa)
      const sahne = this.fikoThreejs?.sahneler?.[0];
      if (!sahne) return [];

      // Ölçümleri topla
      const measurements: any[] = [];
      sahne.traverse((obj: any) => {
        if (obj.userData?.fikoOlcum) {
          measurements.push({
            id: obj.uuid,
            type: obj.userData.fikoOlcum.type || 'distance',
            value: obj.userData.fikoOlcum.value || 0,
            unit: obj.userData.fikoOlcum.unit || 'mm',
            label: obj.userData.fikoOlcum.label || ''
          });
        }
      });

      return measurements;
    };

    // Model bilgisi isteği handler'ı
    this.pdfChannelHost.onModelInfoRequest = () => {
      const sahne = this.fikoThreejs?.sahneler?.[0];
      if (!sahne) return null;

      // Bounding box hesapla
      const box = new THREE.Box3().setFromObject(sahne as any);
      const size = new THREE.Vector3();
      box.getSize(size);

      return {
        filename: (sahne as any).userData?.filename || 'Model',
        dimensions: { x: size.x, y: size.y, z: size.z }
      };
    };

    // Nesne listesi isteği handler'ı
    this.pdfChannelHost.onObjectListRequest = () => {
      const sahne = this.fikoThreejs?.sahneler?.[0];
      if (!sahne) return [];

      const objects: any[] = [];
      sahne.traverse((obj: any) => {
        // FikoCizimYalin nesnelerini listele
        if (obj.type === 'FikoCizimYalin') {
          objects.push({
            id: obj.uuid,
            name: obj.name || obj.userData?.filename || 'Parça ' + (objects.length + 1),
            type: 'FikoCizimYalin',
            hasVolumeData: typeof obj.hacim !== 'undefined',
            hasWeightData: typeof obj.agirlik !== 'undefined'
          });
        }
      });

      return objects;
    };

    // Belirli nesne bilgisi isteği handler'ı
    this.pdfChannelHost.onObjectInfoRequest = (objectId: string) => {
      const sahne = this.fikoThreejs?.sahneler?.[0];
      if (!sahne) return null;

      let targetObj: any = null;
      sahne.traverse((obj: any) => {
        if (obj.uuid === objectId) {
          targetObj = obj;
        }
      });

      if (!targetObj) return null;

      // Bounding box hesapla
      const box = new THREE.Box3().setFromObject(targetObj);
      const size = new THREE.Vector3();
      box.getSize(size);

      const info: any = {
        id: targetObj.uuid,
        filename: targetObj.name || targetObj.userData?.filename || 'Parça',
        dimensions: { x: size.x, y: size.y, z: size.z }
      };

      // FikoCizimYalin ise ek bilgileri ekle
      if (targetObj.type === 'FikoCizimYalin') {
        if (typeof targetObj.hacim !== 'undefined') {
          info.volume = targetObj.hacim;
        }
        if (typeof targetObj.alan !== 'undefined') {
          info.surfaceArea = targetObj.alan;
        }
        if (typeof targetObj.agirlik !== 'undefined') {
          info.weight = targetObj.agirlik;
        }
        if (targetObj.userData?.density) {
          info.density = targetObj.userData.density;
        }
        if (targetObj.userData?.material) {
          info.material = targetObj.userData.material;
        }
      }

      return info;
    };

    // FikoCizimYalin listesi isteği handler'ı
    this.pdfChannelHost.onCizimListRequest = () => {
      const sahne = this.fikoThreejs?.sahneler?.[0];
      if (!sahne) return [];

      const cizimler: any[] = [];
      sahne.traverse((obj: any) => {
        if (obj.type === 'FikoCizimYalin') {
          // Bounding box hesapla
          const box = new THREE.Box3().setFromObject(obj);
          const size = new THREE.Vector3();
          box.getSize(size);

          cizimler.push({
            id: obj.uuid,
            name: obj.name || obj.userData?.filename || 'Parça ' + (cizimler.length + 1),
            type: 'FikoCizimYalin',
            visible: obj.visible,
            dimensions: { x: size.x, y: size.y, z: size.z },
            volume: typeof obj.hacim !== 'undefined' ? obj.hacim : undefined,
            surfaceArea: typeof obj.alan !== 'undefined' ? obj.alan : undefined,
            weight: typeof obj.agirlik !== 'undefined' ? obj.agirlik : undefined,
            material: obj.userData?.material,
            density: obj.userData?.density
          });
        }
      });

      return cizimler;
    };

    // Seçim modu başlatma handler'ı
    this.pdfChannelHost.onStartSelectionMode = () => {
      console.log('[FikoPdfChannelHost] Seçim modu başlatıldı');
      this.pdfSelectionModeActive = true;
      this.cd.detectChanges();
    };

    // Seçim modu iptal handler'ı
    this.pdfChannelHost.onCancelSelectionMode = () => {
      console.log('[FikoPdfChannelHost] Seçim modu iptal edildi');
      this.pdfSelectionModeActive = false;
      this.cd.detectChanges();
    };

    // 3D pencereyi öne getirme handler'ı
    this.pdfChannelHost.onFocusViewer = () => {
      window.focus();
    };
  }

  // PDF editör için seçim modu aktif mi?
  pdfSelectionModeActive = false;

  /**
   * PDF editör için nesne seçimi yap
   * Bu metod, sahne üzerinde tıklama yapıldığında çağrılır
   */
  onPdfObjectSelect(obj: any): void {
    if (!this.pdfSelectionModeActive || !this.pdfChannelHost) return;

    console.log('[FikoPdfChannelHost] Nesne seçildi:', obj);

    // Seçilen nesnenin bilgisini oluştur
    let cizimInfo: any = null;

    if (obj && obj.type === 'FikoCizimYalin') {
      const box = new THREE.Box3().setFromObject(obj);
      const size = new THREE.Vector3();
      box.getSize(size);

      cizimInfo = {
        id: obj.uuid,
        name: obj.name || obj.userData?.filename || 'Seçilen Parça',
        type: 'FikoCizimYalin',
        visible: obj.visible,
        dimensions: { x: size.x, y: size.y, z: size.z },
        volume: typeof obj.hacim !== 'undefined' ? obj.hacim : undefined,
        surfaceArea: typeof obj.alan !== 'undefined' ? obj.alan : undefined,
        weight: typeof obj.agirlik !== 'undefined' ? obj.agirlik : undefined,
        material: obj.userData?.material,
        density: obj.userData?.density
      };
    }

    // Seçim sonucunu gönder
    this.pdfChannelHost.sendSelectionResult(cizimInfo);

    // PDF editörü öne getir
    this.pdfChannelHost.requestFocusEditor();

    // Seçim modunu kapat
    this.pdfSelectionModeActive = false;
    this.cd.detectChanges();
  }

  /**
   * PDF seçim overlay'ine tıklandığında
   * Raycast ile tıklanan nesneyi bul
   */
  onPdfSelectionOverlayClick(event: MouseEvent): void {
    if (!this.pdfSelectionModeActive) return;

    // Banner'a tıklanmışsa işlem yapma
    if ((event.target as HTMLElement).closest('.pdf-selection-banner')) {
      return;
    }

    // Raycast ile nesne bul
    const canvas = this.fikoThreejs?.sunucu?.domElement;
    if (!canvas) return;

    const rect = canvas.getBoundingClientRect();
    const x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
    const y = -((event.clientY - rect.top) / rect.height) * 2 + 1;

    const raycaster = new THREE.Raycaster();
    const mouse = new THREE.Vector2(x, y);
    const camera = this.fikoThreejs?.aktifKamera;
    const scene = this.fikoThreejs?.sahneler?.[0];

    if (!camera || !scene) return;

    raycaster.setFromCamera(mouse, camera);

    // Sadece FikoCizimYalin nesnelerini tarafor
    const cizimler: any[] = [];
    scene.traverse((obj: any) => {
      if (obj.type === 'FikoCizimYalin') {
        cizimler.push(obj);
      }
    });

    const intersects = raycaster.intersectObjects(cizimler, true);

    if (intersects.length > 0) {
      // İlk kesişen nesnenin FikoCizimYalin parent'ını bul
      let obj = intersects[0].object;
      while (obj && obj.type !== 'FikoCizimYalin' && obj.parent) {
        obj = obj.parent;
      }

      if (obj && obj.type === 'FikoCizimYalin') {
        this.onPdfObjectSelect(obj);
      }
    }
  }

  /**
   * PDF seçim modunu iptal et
   */
  cancelPdfSelection(event: MouseEvent): void {
    event.stopPropagation();

    if (this.pdfChannelHost) {
      // Boş sonuç gönder (iptal)
      this.pdfChannelHost.sendSelectionResult(null);
      this.pdfChannelHost.requestFocusEditor();
    }

    this.pdfSelectionModeActive = false;
    this.cd.detectChanges();
  }

  /**
   * Kamerayı belirli bir görünüm açısına ayarla
   * @param camera Kamera objesi
   * @param scene Sahne objesi
   * @param kontrol OrbitControls objesi
   * @param view Görünüm tipi: 'front' | 'back' | 'left' | 'right' | 'top' | 'bottom' | 'iso'
   */
  private setCameraView(
    camera: THREE.Camera,
    scene: THREE.Scene,
    kontrol: any,
    view: string
  ): void {
    // Sahnenin bounding box'ını hesapla
    const box = new THREE.Box3().setFromObject(scene);
    const center = new THREE.Vector3();
    const size = new THREE.Vector3();
    box.getCenter(center);
    box.getSize(size);

    // Modelin en büyük boyutuna göre mesafe hesapla
    const maxDim = Math.max(size.x, size.y, size.z);
    const distance = maxDim * 2; // Model boyutunun 2 katı mesafe

    // Görünüm tipine göre kamera pozisyonunu ayarla
    // Koordinat sistemi: X = sağ, Y = yukarı, Z = kameraya doğru (Three.js varsayılan)
    let position: THREE.Vector3;

    switch (view) {
      case 'front':
        // Önden görünüm (Z+ yönünden bakış)
        position = new THREE.Vector3(center.x, center.y, center.z + distance);
        break;

      case 'back':
        // Arkadan görünüm (Z- yönünden bakış)
        position = new THREE.Vector3(center.x, center.y, center.z - distance);
        break;

      case 'left':
        // Soldan görünüm (X- yönünden bakış)
        position = new THREE.Vector3(center.x - distance, center.y, center.z);
        break;

      case 'right':
        // Sağdan görünüm (X+ yönünden bakış)
        position = new THREE.Vector3(center.x + distance, center.y, center.z);
        break;

      case 'top':
        // Üstten görünüm (Y+ yönünden bakış)
        position = new THREE.Vector3(center.x, center.y + distance, center.z);
        break;

      case 'bottom':
        // Alttan görünüm (Y- yönünden bakış)
        position = new THREE.Vector3(center.x, center.y - distance, center.z);
        break;

      case 'iso':
      default:
        // İzometrik görünüm (köşegen bakış)
        const isoOffset = distance / Math.sqrt(3);
        position = new THREE.Vector3(
          center.x + isoOffset,
          center.y + isoOffset,
          center.z + isoOffset
        );
        break;
    }

    // Kamera pozisyonunu ayarla
    camera.position.copy(position);
    camera.lookAt(center);

    // OrbitControls target'ını güncelle
    if (kontrol?.target) {
      kontrol.target.copy(center);
    }

    // Kontrolü güncelle
    if (kontrol?.update) {
      kontrol.update();
    }

    // Kamera projeksiyon matrisini güncelle
    if ((camera as THREE.PerspectiveCamera).updateProjectionMatrix) {
      (camera as THREE.PerspectiveCamera).updateProjectionMatrix();
    }
  }

  async arModuToggle(): Promise<void> {
    if (!this.arModuAktif) this.komutKampanya('GORUNTULEME', 'ar_modu', 'AR Modu (Kamera Arka Plan)');
    if (this.arModuAktif) {
      this.arModu.durdur();
      this.fikoThreejs.arModuKapat();
      this.arModuAktif = false;
    } else {
      const canvasParent = this.fikoThreejs.canvas.nativeElement.parentNode as HTMLElement;
      const basarili = await this.arModu.basla(
        canvasParent,
        this.fikoThreejs.sunucu,
        this.fikoThreejs.aktifKamera,
        this.fikoThreejs.aktifKontrol,
        () => this.fikoThreejs.markNeedsRender()
      );
      if (basarili) {
        this.fikoThreejs.arModuAc(this.arModu);
        this.arModuAktif = true;
      } else {
        this.nzMessage.error('Kamera erişimi sağlanamadı');
      }
    }
    this.arGyroAktif = false;
    this.cd.detectChanges();
  }

  async arAnchorToggle(): Promise<void> {
    if (this.arModu.anchor.kilitli) {
      this.arModu.serbest();
      if (this.arGyroAktif && this.arModu.kontrol) {
        this.arModu.kontrol.gyroToggle();
        this.arGyroAktif = false;
      }
    } else {
      this.arModu.sabitle();
      if (!this.arGyroAktif && this.arModu.kontrol) {
        const izin = await this.arModu.kontrol.gyroIzinIste();
        if (izin) this.arGyroAktif = true;
      }
    }
    this.cd.detectChanges();
  }

  async arGyroToggle(): Promise<void> {
    if (!this.arModu.kontrol) return;
    if (!this.arGyroAktif) {
      const izin = await this.arModu.kontrol.gyroIzinIste();
      if (!izin) {
        this.nzMessage.warning('Gyroscope erişimi sağlanamadı');
        return;
      }
      this.arGyroAktif = true;
    } else {
      this.arModu.kontrol.gyroToggle();
      this.arGyroAktif = false;
    }
    this.cd.detectChanges();
  }

  ngOnDestroy(): void {
    this.arModu.dispose();
    try { this.cam?.temizle(); this.cam = null; this.cam3dStokTemizle(); } catch (e) { }   // CAM: RAF + canvas/window listener + THREE kaynak + saydam stok temizliği
    super.ngOnDestroy();

    // 🌳 TREE SYNC: Subscription temizle
    if (this.treeStateSubscription) {
      this.treeStateSubscription.unsubscribe();
      this.treeStateSubscription = null;
    }

    // 📦 Parça Takip listener temizle
    if (this._parcaTakipListener) { window.removeEventListener('fiko:parca-takip', this._parcaTakipListener); this._parcaTakipListener = null; }

    // PDF Channel'ı temizle
    this.pdfChannelHost?.destroy();
    this.pdfChannelHost = null;

    // NPR Renderer'ı temizle
    this.nprRenderer.dispose();
  }

  /**
   * window.dosya kontrolü - StepAnalyzer'dan gelen STEP dosyasını otomatik yükler
   */
  okuPencereDosya(): void {
    // @ts-ignore
    if (!window.dosya) {
      return;
    }

    // @ts-ignore
    const dosya = window.dosya;

    // Dosya tipini kontrol et
    if (dosya instanceof File) {
      const fileName = dosya.name.toLowerCase();

      // STEP dosyası kontrolü
      if (fileName.endsWith('.stp') || fileName.endsWith('.step')) {
        const sahne = this.fikoThreejs.sahneler[0] as SahneStepViewer;
        const importer = new FikoImporter(sahne.cizimler);

        // Dosyayı yükle - FikoImporter'ın içindeki mevcut STP yükleme mantığını kullan
        importer.stpDosyasiniYukle(dosya).then((cizim: any) => {
          // Sahneye ekle
          sahne.cizimler.ekle(cizim);

          // Sahneyi güncelle
          if (sahne.anaGosterim) {
            sahne.anaGosterim.ciz();

            // Model yüklendikten sonra otomatik ekrana sığdır
            setTimeout(() => {
              if (sahne && typeof sahne.ekranaSigdir === 'function') {
                // sahne.ekranaSigdir(sahne);
              }
            }, 100);
          }

          // @ts-ignore
          window.dosya = undefined; // Temizle
        }).catch(error => {
          alert(`STEP dosyası yüklenemedi: ${error.message || error}`);
        });
      }
    }
  }

  async tiklandiImportFikoOpGL() {
    const sahne = this.fikoThreejs.sahneler[0] as SahneStepViewer;
    const importer = new FikoImporter(sahne.cizimler);
    const sonuc = await importer.dosyadan(FILE_DIALOG_FORMATS.join(','), true);

    // Sonucu kontrol et - tek dosya veya çoklu dosya
    if (sonuc) {
      // Çoklu dosya sonucu
      if ('yuklenen' in (sonuc as any)) {
        const cokluSonuc = sonuc as { yuklenen: number; hatali: number; sonuclar: any[] };
        if (cokluSonuc.yuklenen > 0) {
          // Her dosya için bildirim gönder
          for (const item of cokluSonuc.sonuclar) {
            const dosyaAdi = item.name || 'Bilinmeyen dosya';
            const uzanti = dosyaAdi.split('.').pop() || 'bilinmiyor';
            this.bildirim.dosyaAcildi(dosyaAdi, uzanti, 0);
          }
        }
      }
      // Tek dosya sonucu
      else if ('name' in (sonuc as any)) {
        const tekSonuc = sonuc as { name: string; size: number; type: string };
        const dosyaAdi = tekSonuc.name;
        const uzanti = dosyaAdi.split('.').pop() || 'bilinmiyor';
        const boyut = tekSonuc.size;
        this.bildirim.dosyaAcildi(dosyaAdi, uzanti, boyut);
      }
    }
  }


  /**
   * 📦 Parça Takip — Sahnede parça YÜKLÜYSE onu kullan (ağırlık/ölçü OTOMATİK), yoksa STP yükle.
   * Lib→app statik bağımlılığı yok: dialog DİNAMİK import edilir.
   */
  /** 3D workbench/komut lisansı (ModulService köprüsü; köprü yoksa AÇIK). lisans('OLCUM') veya lisans('OLCUM','kumpas'). */
  lisans(wb: string, komut?: string): boolean { try { return (window as any).__fikoModul?.(wb, komut) ?? true; } catch { return true; } }
  /** Kampanyalı komut kullanılınca "normalde ücretli, şimdilik ücretsiz" bildir (gating yok, oturumda 1 kez). */
  komutKampanya(wb: string, komut: string, ad: string): void { try { (window as any).__fikoKampanyaBildir?.(wb, komut, ad); } catch { } }

  async parcaTakipAc(): Promise<void> {
    const sahne: any = this.fikoThreejs?.sahneler?.[0];
    const olc = this._parcaSahneOlc(sahne);
    // ÖNCELİK: modelleme yöneticisinin DOĞRU hesabı (gerçek katı hacim + KULLANICININ SEÇTİĞİ malzeme) — sahne taramasındaki çift sayım/sabit çelik hatasını önler
    const my: any = this.modelleme;
    const bilgi = my?.govdeBilgi;
    if (bilgi && bilgi.agirlikG > 0) {
      const o2 = my.govdeOlcu?.();
      const onAgirlik = +(bilgi.agirlikG / 1000).toFixed(2);
      const onBoyut = o2 ? { x: o2.x, y: o2.y, z: o2.z } : olc?.onBoyut;
      const fp = olc?.fingerprint || { fp: `m_v${Math.round(bilgi.hacimCm3)}`, faceSayisi: bilgi.govdeAdet, edgeSayisi: 0, hacim: bilgi.hacimCm3 };
      const ad = olc?.parcaAd || sahne?.cizimler?.children?.[0]?.name || 'Parça';
      this._parcaDialogAc(sahne, fp, ad, onAgirlik, onBoyut, bilgi.malzeme, bilgi.hacimCm3, my.malzemeSecenekleri); return;
    }
    if (olc) { this._parcaDialogAc(sahne, olc.fingerprint, olc.parcaAd, olc.onAgirlik, olc.onBoyut); return; }   // sahnedeki parça (modelleme yoksa: import mesh)
    // sahne boş → STP yükle
    const inp = document.createElement('input'); inp.type = 'file'; inp.accept = '.stp,.step';
    inp.onchange = async () => {
      const f = inp.files?.[0]; if (!f || !sahne) return;
      try {
        const bytes = new Uint8Array(await f.arrayBuffer());
        if (!(await this.modellemeAl().disStepAl(bytes))) throw new Error('brep yok');
        sahne?.anaGosterim?.FikoYT?.degisti?.emit?.();
      } catch { try { await new FikoImporter(sahne.cizimler).dosyalardanYukle([f]); } catch (e) { } }
      this.fikoThreejs?.ciz?.();
      // yükledikten sonra sahneden otomatik ölçü/ağırlık + GEOMETRİ fingerprint (sahneyle TUTARLI tanıma)
      await new Promise(r => setTimeout(r, 600));
      const o2 = this._parcaSahneOlc(sahne);
      let fingerprint = o2?.fingerprint;
      if (!fingerprint) {   // geometri alınamazsa dosya metninden
        const text = await f.text();
        const fc = (text.match(/ADVANCED_FACE/g) || []).length, ec = (text.match(/EDGE_CURVE/g) || []).length;
        fingerprint = { fp: `f${fc}_e${ec}_v${Math.round(f.size / 1024)}`, faceSayisi: fc, edgeSayisi: ec, hacim: Math.round(f.size / 1024) };
      }
      this._parcaDialogAc(sahne, fingerprint, f.name.replace(/\.(stp|step)$/i, ''), o2?.onAgirlik, o2?.onBoyut);
    };
    inp.click();
  }

  /** Sahnedeki yüklü parçadan otomatik ölçü (bbox) + ağırlık (mesh hacim × yoğunluk) + fingerprint. */
  private _parcaSahneOlc(sahne: any): { fingerprint: any; parcaAd: string; onAgirlik: number; onBoyut: { x: number; y: number; z: number } } | null {
    if (!sahne) return null;
    // Tüm sahneyi tara (B-Rep modelleme + mesh import farklı gruplara gidebilir); yardımcıları/işaretleri ele.
    const haric = /grid|helper|gizmo|eksen|axis|yön|yon|isaret|olcu|annotation|ParcaNot|kafa|ozmo|triad|kamera|camera|light|ışık/i;
    const kokler = [sahne.cizimler, sahne.operasyonlar, sahne.urunAgaci, sahne].filter(Boolean);
    const meshSet = new Set<THREE.Mesh>();
    for (const kok of kokler) kok.traverse?.((o: any) => {
      if (o.isMesh && o.geometry?.attributes?.position && o.visible !== false && !haric.test(o.name || '') && !haric.test(o.parent?.name || '')) meshSet.add(o);
    });
    const meshler = [...meshSet];
    if (!meshler.length) return null;
    const box = new THREE.Box3(); for (const m of meshler) box.expandByObject(m);
    if (box.isEmpty()) return null;
    const size = box.getSize(new THREE.Vector3());
    let hacimMm3 = 0, tris = 0;
    for (const m of meshler) { hacimMm3 += this._meshHacim(m); tris += this._triSayi(m); }
    const hacimCm3 = Math.abs(hacimMm3) / 1000;
    const onAgirlik = +((hacimCm3 * 7.85) / 1000).toFixed(2);   // çelik 7.85 g/cm³ → kg
    const onBoyut = { x: +size.x.toFixed(1), y: +size.y.toFixed(1), z: +size.z.toFixed(1) };
    const ad = (sahne?.cizimler?.children?.[0]?.name || meshler[0]?.name || meshler[0]?.parent?.name || 'Sahne Parçası').toString();
    const fingerprint = { fp: `s_t${Math.round(tris)}_v${Math.round(hacimCm3)}`, faceSayisi: meshler.length, edgeSayisi: 0, hacim: hacimCm3 };
    return { fingerprint, parcaAd: ad, onAgirlik, onBoyut };
  }
  private _triSayi(m: any): number { const g = m.geometry; return g.index ? g.index.count / 3 : (g.attributes.position.count / 3); }
  private _meshHacim(m: any): number {
    const g = m.geometry, pos = g.attributes.position, idx = g.index; m.updateMatrixWorld();
    const mat = m.matrixWorld, a = new THREE.Vector3(), b = new THREE.Vector3(), c = new THREE.Vector3(), t = new THREE.Vector3();
    let v = 0; const n = idx ? idx.count : pos.count;
    for (let i = 0; i < n; i += 3) {
      const ia = idx ? idx.getX(i) : i, ib = idx ? idx.getX(i + 1) : i + 1, ic = idx ? idx.getX(i + 2) : i + 2;
      a.fromBufferAttribute(pos, ia).applyMatrix4(mat); b.fromBufferAttribute(pos, ib).applyMatrix4(mat); c.fromBufferAttribute(pos, ic).applyMatrix4(mat);
      v += a.dot(t.copy(b).cross(c)) / 6;
    }
    return v;   // mm³
  }
  private async _parcaDialogAc(sahne: any, fingerprint: any, parcaAd: string, onAgirlik?: number, onBoyut?: any, malzeme?: string, hacimCm3?: number, malzemeler?: { ad: string; yogunluk: number }[]): Promise<void> {
    try {
      const mod: any = await import('@/src/app/uygulamalar/parca-takip/fiko-parca-takip-dialog');
      this.DialogFiko.ac({
        bilesen: mod.FikoParcaTakipDialog, id: 'fiko-parca-takip',
        ayarlar: { baslik: '📦 Parça Takip', simgeResim: '/simgeler/logo.webp', modalMi: false, sinirlandi: false, boyut: { w: 340, h: 'auto' } },
        parametreler: { fingerprint, parcaAd, sahne, taninan: null, onAgirlik, onBoyut, onMalzeme: malzeme, onHacimCm3: hacimCm3, onMalzemeler: malzemeler },
      });
    } catch (e) { console.warn('Parça takip dialog açılamadı', e); }
  }

  /**
   * Komple Kaydet - tüm sahneyi streaming gzip ile kaydeder (büyük geometri verisi için)
   */
  async kompleKaydet() {
    // Double-click koruması
    if (this._kaydetmeAktif) return;
    this._kaydetmeAktif = true;

    try {
      const sahne = this.fikoThreejs.sahneler[0] as SahneStepViewer;
      if (!sahne) return;

      // Dosya adını belirle
      const isim = sahne.cizimler?.children?.[0]?.name
        || sahne.operasyonlar?.children?.[0]?.name
        || 'FikoYT-Sahne';

      // Streaming serialization — her parçayı ayrı ayrı JSON.stringify edip gzip'e akıt
      const blob = await this.sahneStreamKaydet(sahne);

      // @ts-ignore - File System Access API
      if (typeof window !== 'undefined' && window.showSaveFilePicker) {
        try {
          // @ts-ignore
          const handle = await window.showSaveFilePicker({
            suggestedName: isim + '.FikoSahne',
            types: [{
              description: 'FikoYT Sahne Dosyası',
              accept: { 'application/octet-stream': ['.FikoSahne'] },
            }],
          });
          const writable = await handle.createWritable();
          await writable.write(blob);
          await writable.close();
          this.bildirim.dosyaAcildi(isim + '.FikoSahne', 'FikoSahne', blob.size);
          return;
        } catch (e) {
          if ((e as any)?.name === 'AbortError') return;
        }
      }

      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = isim + '.FikoSahne';
      a.click();
      URL.revokeObjectURL(url);
      this.bildirim.dosyaAcildi(isim + '.FikoSahne', 'FikoSahne', blob.size);
    } finally {
      this._kaydetmeAktif = false;
    }
  }

  /**
   * Binary Container Format ile sahneyi kaydeder.
   * Geometri verileri ham binary olarak saklanır (base64 overhead yok).
   * Format: Gzip{ MAGIC(9) + VER(1) + JSON_LEN(4) + JSON + BUF_COUNT(4) + [LEN(4)+DATA]... }
   */
  private async sahneStreamKaydet(sahne: SahneStepViewer): Promise<Blob> {
    // 1) Binary toplama modunu başlat
    FikoCizimYalin.startBinaryCollect();

    // 2) JSON metadata oluştur (geometri verileri _bin referansları olarak)
    const jsonObj: any = {
      versiyon: '3.0.0',
      format: 'binary-container',
      tarih: new Date().toISOString(),
    };

    // Kamera durumu
    const kamera = this.fikoThreejs.aktifKamera;
    const kontrol = this.fikoThreejs.aktifKontrol;
    if (kamera && kontrol) {
      jsonObj.kameraDurumu = {
        position: kamera.position.toArray(),
        quaternion: kamera.quaternion.toArray(),
        up: kamera.up.toArray(),
        zoom: kamera.zoom,
        hedef: kontrol.target.toArray(),
      };
    }

    // Konumlar
    if (sahne.kaynakca?.konumlar) {
      jsonObj.konumlar = sahne.kaynakca.konumlar.toJSON();
    }

    // Etiketler
    if (sahne.fikoEtiketler?.children?.length > 0) {
      jsonObj.etiketler = sahne.fikoEtiketler.toJSON();
    }

    // Çizimler (toJSON binary collector aktifken _bin referansları üretir)
    if (sahne.cizimler) {
      jsonObj.cizimler = sahne.cizimler.toJSON();
    }

    // Operasyonlar
    if (sahne.operasyonlar) {
      jsonObj.operasyonlar = sahne.operasyonlar.toJSON();
    }

    // Parametrik modelleme (feature geçmişi + sketch + ölçüler)
    try { const m = this.modelleme?.serialize(); if (m) jsonObj.modelleme = m; } catch (e) { console.warn('[Kaydet] modelleme serialize hatası', e); }

    // Kalıcı ölçümler (yeniden kurulabilir kayıtlar: nokta/tip/değer)
    try {
      let ko: any = null;
      this.fikoThreejs.sahneler[0]?.traverse?.((o: any) => { if (o.type === 'FikoKaliciOlcumler') ko = o; });
      const kayitlar = ko?.kayitlariAl?.();
      if (kayitlar?.length) jsonObj.olcumler = kayitlar;
    } catch (e) { console.warn('[Kaydet] ölçüm serialize hatası', e); }

    // 3) Binary buffer'ları topla
    const binBuffers = FikoCizimYalin.endBinaryCollect();

    // 4) JSON → UTF-8 bytes
    const encoder = new TextEncoder();
    const jsonStr = JSON.stringify(jsonObj);
    const jsonBytes = encoder.encode(jsonStr);

    // Debug: boyut raporu
    let binTotal = 0;
    for (const b of binBuffers) binTotal += b.length;
    console.log(`[FikoSahne Kaydet] JSON: ${(jsonBytes.length / 1024).toFixed(0)} KB | Binary buffer: ${binBuffers.length} adet, toplam ${(binTotal / 1024 / 1024).toFixed(1)} MB`);

    // 5) Binary container oluştur ve gzip'le
    const MAGIC = encoder.encode('FIKOSAHNE');
    const readable = new ReadableStream({
      start(controller) {
        controller.enqueue(MAGIC);
        controller.enqueue(new Uint8Array([3]));

        const jsonLenBuf = new Uint8Array(4);
        new DataView(jsonLenBuf.buffer).setUint32(0, jsonBytes.length, true);
        controller.enqueue(jsonLenBuf);
        controller.enqueue(jsonBytes);

        const bufCountBuf = new Uint8Array(4);
        new DataView(bufCountBuf.buffer).setUint32(0, binBuffers.length, true);
        controller.enqueue(bufCountBuf);

        for (const buf of binBuffers) {
          const lenBuf = new Uint8Array(4);
          new DataView(lenBuf.buffer).setUint32(0, buf.length, true);
          controller.enqueue(lenBuf);
          controller.enqueue(buf);
        }
        controller.close();
      }
    });

    const compressed = readable.pipeThrough(new CompressionStream('gzip'));
    return new Response(compressed).blob();
  }

  /**
   * Aktif operasyonu sıkıştırmalı olarak kaydeder (.FikoOp)
   */
  async operasyonKaydet() {
    const sahne = this.fikoThreejs.sahneler[0] as SahneStepViewer;
    if (!sahne?.operasyonlar?.children?.length) return;

    // Aktif operasyonu veya ilk operasyonu kaydet
    const aktifItem = this.fikoThreejs.aktifItem;
    const op = (aktifItem as any)?.dosyayaKaydet
      ? aktifItem
      : sahne.operasyonlar.children[0];

    if ((op as any)?.dosyayaKaydet) {
      await (op as any).dosyayaKaydet();
    }
  }

  private async gzipSikistir(veri: string): Promise<Blob> {
    const encoder = new TextEncoder();
    const stream = new Blob([encoder.encode(veri)]).stream();
    const compressed = stream.pipeThrough(new CompressionStream('gzip'));
    return new Response(compressed).blob();
  }

  hashCode(str: string): number {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = ((hash << 5) - hash) + str.charCodeAt(i);
      hash |= 0; // int'e indir
    }
    return Math.abs(hash % 999); // sınırlı ID
  }

  /**
   * Seçim modunu aç/kapat
   */
  toggleSecimModu() {
    if (this.fikoThreejs?.sahneler?.[0]?.secimler) {
      this.fikoThreejs.sahneler[0].secimler.aktif = !this.fikoThreejs.sahneler[0].secimler.aktif;
      this.FikoYT.degisti.emit();
    }
  }

  /** Mevcut topolojik seçim modu */
  topolojikSecimModu: string = 'tek_kenar';
  topolojikSecimModuEtiket: string = 'Tek Kenar';

  /** Topolojik seçim modlarını sırayla değiştir */
  toggleTopolojikSecimModu() {
    const secimler = this.fikoThreejs?.sahneler?.[0]?.secimler;
    if (!secimler) return;

    const modlar = secimler.getTopolojikSecimModlari();
    const mevcutIdx = modlar.findIndex((m: any) => m.mod === this.topolojikSecimModu);
    const sonrakiIdx = (mevcutIdx + 1) % modlar.length;
    const yeniMod = modlar[sonrakiIdx];

    secimler.setTopolojikSecimModu(yeniMod.mod);
    this.topolojikSecimModu = yeniMod.mod;
    this.topolojikSecimModuEtiket = yeniMod.etiket;
    this.FikoYT.degisti.emit();
  }

  /**
   * 🖼️ Resimden 3D dialogunu açar (ComfyUI / FikoYT-img2-3d iş akışı).
   * Kullanıcı resim seçer → ComfyUI dokulu GLB üretir → sahneye renkli eklenir.
   */
  async acFikoAi3DDialog() {
    this.bildirim.aracKullanildi('Resimden 3D');

    const mod: any = await import('../IFikoThreeJS/fiko-ai-3d/fiko-ai-3d-dialog.component');

    this.fikoThreejs.DialogFiko.ac({
      bilesen: mod.FikoAi3DDialogComponent,
      id: "FikoYT-Ai-3d",
      ayarlar: {
        baslik: "FikoYT Resimden 3D",
        simgeResim: "/simgeler/logo.webp",
        modalMi: false,
        boyut: { w: 350, h: 'auto' }
      },
      parametreler: {
        anaGosterim: this.fikoThreejs
      },
    } as any);
  }

  /**
   * Fiko ölçüm dialogunu açar
   */
  acFikoOlcumDialog() {
    // Bildirim gönder
    this.bildirim.aracKullanildi('Ölçüm');

    // NOT: DialogFiko.ac kendi DOM'unu yönetir — manuel element oluşturma orphaned div bırakıyordu.

    // Dialog'ı aç
    this.fikoThreejs.DialogFiko.ac({
      bilesen: FikoOlcumComponent,
      id: "FikoYT-Olcum-3d",
      ayarlar: {
        baslik: "FikoYT Ölçüm",
        simgeResim: "./simgeler/logo.webp"
      },
      parametreler: {
        anaGosterim: this.fikoThreejs
      },
    });
  }

  /**
   * Fiko ters açı analizi dialogunu açar
   */
  acFikoTersAciAnaliziDialog() {
    // Bildirim gönder
    this.bildirim.aracKullanildi('Ters Açı Analizi');
    this.komutKampanya('ANALIZ', 'ters_aci', 'Ters Açı (Undercut)');

    // NOT: DialogFiko.ac kendi DOM'unu yönetir — manuel element oluşturma orphaned div bırakıyordu.

    // Ters açı analizi dialog'ını aç
    this.fikoThreejs.DialogFiko.ac({
      bilesen: FikoAnalizComponent,
      id: "FikoYT-TersAci-Analizi-3d",
      ayarlar: {
        baslik: "FikoYT Analiz",
        simgeResim: "/simgeler/xyz-1.webp"
      },
      parametreler: {
        anaGosterim: this.fikoThreejs
      },
    });
  }

  /**
   * Fiko-Kesit (Dinamik Kesit) dialogunu açar
   */
  acFikoKesitDialog() {
    // Bildirim gönder
    this.bildirim.aracKullanildi('Dinamik Kesit');
    this.komutKampanya('GORUNTULEME', 'kesit_gorunum', 'Kesit Görünümü');

    // NOT: DialogFiko.ac kendi DOM'unu yönetir — manuel element oluşturma orphaned div bırakıyordu.

    // Dinamik kesit dialog'ını aç
    this.fikoThreejs.DialogFiko.ac({
      bilesen: FikoDinamikKesitComponent,
      id: "FikoYT-Dinamik-Kesit-3d",
      ayarlar: {
        baslik: "Dinamik Kesit",
        simgeResim: "./simgeler/cetvel.webp",
        width: '420px',
        height: '90vh'
      },
      parametreler: {
        anaGosterim: this.fikoThreejs
      },
    });
  }

  /**
   * Fiko radius analizi dialogunu açar
   */
  acFikoRadiusAnaliziDialog() {
    // Bildirim gönder
    this.bildirim.aracKullanildi('Radius Analizi');
    this.komutKampanya('ANALIZ', 'radius', 'Radius / Erişilebilirlik');

    // NOT: DialogFiko.ac kendi DOM'unu yönetir — manuel element oluşturma orphaned div bırakıyordu.

    // Radius analizi dialog'ını aç
    this.fikoThreejs.DialogFiko.ac({
      bilesen: RadiusAnalysisComponent,
      id: "FikoYT-Radius-Analizi-3d",
      ayarlar: {
        baslik: "FikoYT Radius Analizi",
        simgeResim: "/simgeler/vektor-sec.webp"
      },
      parametreler: {
        anaGosterim: this.fikoThreejs
      },
    });
  }

  /**
   * Dikine Bak - Yüzey seçimi yapıp seçilen yüzeye dik olarak kamerayı konumlandırır
   */
  /**
   * 🎯 Ekrana Sığdır - Modeli ekrana tam sığdıracak şekilde zoom ve pozisyon ayarlar
   */
  ekranaSigdir() {
    // Bildirim gönder
    this.bildirim.aracKullanildi('Ekrana Sığdır');

    // Modelleme modunda: gövde + makro + yüzey + tel-kafes tümünü kapsa (motor fit'i modelleme grubunu atlıyor)
    if (this.modellemeAcik && this.modelleme) {
      try { this.modelleme.kameraSigdir(); return; } catch (e) { }
    }

    const sahne = this.fikoThreejs?.sahneler?.[0];
    if (!sahne) {
      alert('Sahne bulunamadı. Lütfen önce bir model yükleyin.');
      return;
    }

    // Point Cloud kontrolü - fitToScreen metodu varsa onu kullan
    let pointCloudHandled = false;
    sahne.traverse((obj: any) => {
      if (!pointCloudHandled && obj.type === 'FikoPointCloud' && typeof obj.fitToScreen === 'function') {
        obj.fitToScreen();
        pointCloudHandled = true;
      }
    });

    if (pointCloudHandled) {
      return;
    }

    // Normal ekranaSigdir
    if (typeof sahne.ekranaSigdir !== 'function') {
      alert('Ekrana sığdır fonksiyonu bulunamadı.');
      return;
    }

    sahne.ekranaSigdir();
  }

  dikineBak() {
    // Bildirim gönder
    this.bildirim.aracKullanildi('Dikine Bak');

    const sahne = this.fikoThreejs.sahneler?.[0];
    if (!sahne) {
      return;
    }

    // Tüm mesh'leri topla
    const meshler: any[] = [];
    sahne.traverse((obj: any) => {
      if (obj.type === 'Mesh' && obj.geometry) {
        meshler.push(obj);
      }
    });

    if (meshler.length === 0) {
      alert('Dikine bakılacak yüzey bulunamadı. Lütfen önce bir model yükleyin.');
      return;
    }

    // Yüzey seçim sistemini başlat
    const fikoSecimYuzey = sahne.secimler;
    if (!fikoSecimYuzey) {
      return;
    }

    // Önceki seçimleri temizle
    fikoSecimYuzey.bitir();

    // Mesh'leri rayObje olarak ayarla
    fikoSecimYuzey.rayObje = meshler;
    fikoSecimYuzey.filitreler = ["Mesh"];
    fikoSecimYuzey.raycaster.params.Mesh = { threshold: 0 };

    // Kullanıcıya bilgi ver (UI'da gösterilecek)

    // Tek seferlik tıklama event'i
    const tiklamaSub = fikoSecimYuzey.tiklandi.subscribe((kesisim: any) => {
      if (!kesisim) {
        tiklamaSub.unsubscribe();
        fikoSecimYuzey.bitir();
        return;
      }

      // Face normal'ı al
      let faceNormal: any = null;
      const actualMesh = kesisim?.altObje || kesisim?.object;
      const mesh = actualMesh as any;

      // THREE modülünü güvenli şekilde al
      const ThreeLib = THREE || (window as any).THREE;
      if (!ThreeLib) {
        console.error('THREE.js modülü bulunamadı');
        tiklamaSub.unsubscribe();
        fikoSecimYuzey.bitir();
        return;
      }

      if (kesisim?.face?.normal) {
        // Eski API
        const localNormal = kesisim.face.normal.clone();
        const normalMatrix = new ThreeLib.Matrix3().getNormalMatrix(mesh.matrixWorld);
        faceNormal = localNormal.applyMatrix3(normalMatrix).normalize();
      } else if (mesh.geometry && kesisim.faceIndex !== undefined) {
        // Yeni API - geometry normal'ından hesapla
        const geometry = mesh.geometry;
        const normalAttr = geometry.getAttribute('normal');
        if (normalAttr) {
          const faceIndex = kesisim.faceIndex;
          const localNormal = new ThreeLib.Vector3(
            normalAttr.getX(faceIndex),
            normalAttr.getY(faceIndex),
            normalAttr.getZ(faceIndex)
          );
          const normalMatrix = new ThreeLib.Matrix3().getNormalMatrix(mesh.matrixWorld);
          faceNormal = localNormal.applyMatrix3(normalMatrix).normalize();
        }
      }

      if (!faceNormal) {
        tiklamaSub.unsubscribe();
        fikoSecimYuzey.bitir();
        return;
      }

      // Kesişim noktasını al (kamera bu noktaya bakacak)
      const kesisimNoktasi = kesisim.point.clone();

      // Kamera mesafesini hesapla - mevcut zoom seviyesini koru
      const mevcutMesafe = this.fikoThreejs.aktifKamera.position.distanceTo(
        this.fikoThreejs.aktifKontrol.target
      );

      // Kamerayı yüzeye dik konumlandır
      const yeniKameraPoz = kesisimNoktasi.clone().add(
        faceNormal.clone().multiplyScalar(mevcutMesafe)
      );

      // Animasyonlu geçiş
      this.fikoThreejs.surekliCiz();

      const kameraTween = new (window as any).TWEEN.Tween({
        x: this.fikoThreejs.aktifKamera.position.x,
        y: this.fikoThreejs.aktifKamera.position.y,
        z: this.fikoThreejs.aktifKamera.position.z
      })
        .to({
          x: yeniKameraPoz.x,
          y: yeniKameraPoz.y,
          z: yeniKameraPoz.z
        }, 500)
        .easing((window as any).TWEEN.Easing.Quadratic.Out)
        .onUpdate((val: any) => {
          this.fikoThreejs.aktifKamera.position.set(val.x, val.y, val.z);
          this.fikoThreejs.aktifKamera.updateProjectionMatrix();
        });

      const kontrolTween = new (window as any).TWEEN.Tween({
        x: this.fikoThreejs.aktifKontrol.target.x,
        y: this.fikoThreejs.aktifKontrol.target.y,
        z: this.fikoThreejs.aktifKontrol.target.z
      })
        .to({
          x: kesisimNoktasi.x,
          y: kesisimNoktasi.y,
          z: kesisimNoktasi.z
        }, 500)
        .easing((window as any).TWEEN.Easing.Quadratic.Out)
        .onUpdate((val: any) => {
          this.fikoThreejs.aktifKontrol.target.set(val.x, val.y, val.z);
          this.fikoThreejs.aktifKontrol.update();
        });

      kameraTween.start();
      kontrolTween.start();

      Promise.all([
        new Promise<void>(resolve => kameraTween.onComplete(() => resolve())),
        new Promise<void>(resolve => kontrolTween.onComplete(() => resolve()))
      ]).then(() => {
        this.fikoThreejs.surekliCizIptal();
        // Dik bakış tamamlandı
      });

      // Seçim sistemini kapat
      tiklamaSub.unsubscribe();
      fikoSecimYuzey.bitir();
    });

    // Seçim sistemini aktifleştir
    fikoSecimYuzey.baslat();
    fikoSecimYuzey.aktif = true;
  }

  /**
   * 📝 Annotation Toolbar'ını aç/kapat
   * ViewChild-based direct toggle
   */
  acAnnotationToolbar() {
    console.log('[Fiko3D] acAnnotationToolbar() çağrıldı');
    console.log('[Fiko3D] annotationToolbarRef:', this.annotationToolbarRef);
    console.log('[Fiko3D] FikoYT.toolbarService:', this.FikoYT.toolbarService);

    // Bildirim gönder
    this.bildirim.aracKullanildi('Annotation Toolbar');

    // ViewChild referansı üzerinden toggle et
    if (this.annotationToolbarRef) {
      console.log('[Fiko3D] ViewChild üzerinden toggle çağrılıyor...');
      this.annotationToolbarRef.toggle();
    } else {
      console.log('[Fiko3D] ViewChild yok, Service üzerinden deneniyor...');
      // Fallback: Service üzerinden dene
      const mevcutToolbar = this.FikoYT.toolbarService?.bul('annotationTools');
      console.log('[Fiko3D] Service\'den bulunan toolbar:', mevcutToolbar);
      if (mevcutToolbar) {
        mevcutToolbar.toggle();
      } else {
        console.warn('[Fiko3D] Annotation toolbar bulunamadı! Kayıtlı ID\'ler:', this.FikoYT.toolbarService?.tumIdleriAl());
      }
    }
  }

  /**
   * CSS3D Annotation dialogunu aç - Profesyonel CAD-style annotation
   */
  openCSS3DAnnotationDialog(): void {
    if (!this.fikoThreejs.sahneler?.[0]?.anaGosterim) return;

    // Bildirim gönder
    this.bildirim.aracKullanildi('Smart Point 3D');

    this.DialogFiko.ac({
      bilesen: FikoSmartPointComponent,
      id: 'fiko-smart-point-3d-dialog',
      ayarlar: {
        baslik: 'Smart Point 3D',
        modalMi: false,
        sinirlandi: false,
        boyut: { w: 200, h: 'auto' }
      },
      parametreler: {
        anaGosterim: this.fikoThreejs.sahneler?.[0]?.anaGosterim
      }
    });
  }

  /**
   * DFM Analizi Dialog - Design for Manufacturing
   * Üretim öncesi tasarım kontrolü ve maliyet analizi
   */
  acFikoDFMDialog(): void {
    // Bildirim gönder
    this.bildirim.aracKullanildi('DFM Analiz');
    this.komutKampanya('ANALIZ', 'dokum', 'Döküm / DFM Analizi');

    this.DialogFiko.ac({
      bilesen: FikoDFMComponent,
      id: 'fiko-dfm-dialog',
      ayarlar: {
        baslik: 'DFM Analizi',
        simgeResim: '/simgeler/islemci.png',
        modalMi: false,
        sinirlandi: false,
        boyut: { w: 320, h: 'auto' }
      },
      parametreler: {
        anaGosterim: this.fikoThreejs
      }
    });
  }

  /**
   * Koç Kafa Dialog - Mini 3D Test
   * Dialog içinde bağımsız mini 3D viewer örneği
   */
  acKocKafaDialog(): void {
    // Bildirim gönder
    this.bildirim.aracKullanildi('Diagonal Kafa');
    this.komutKampanya('ACILI_KAFA', 'diagonal', 'Diagonal Kafa (WTEC)');

    this.DialogFiko.ac({
      bilesen: FikoKocKafaDialogComponent,
      id: 'fiko-koc-kafa-dialog',
      ayarlar: {
        baslik: 'FikoYT Diagonal Kafa',
        simgeResim: '/simgeler/diagonal-kafa.svg'
      },
      parametreler: {}
    });
  }

  /**
   * Ozmo Kafa Dialog - FikoYT Ozmo Kafa sistemi
   * Dialog içinde bağımsız mini 3D viewer ile Ozmo Kafa kontrolü
   */
  acOzmoKafaDialog(): void {
    // Bildirim gönder
    this.bildirim.aracKullanildi('Ozmo Kafa');
    this.komutKampanya('ACILI_KAFA', 'ozmo', 'Ozmo Kafa');

    this.DialogFiko.ac({
      bilesen: FikoOzmoKafaDialogComponent,
      id: 'fiko-ozmo-kafa-dialog',
      ayarlar: {
        baslik: 'FikoYT Ozmo Kafa',
        simgeResim: '/simgeler/ozmo-kafa.svg'
      },
      parametreler: {}
    });
  }

  /**
   * 3D Çizgi Dialog - FikoYT 3D Çizgi oluşturma ve düzenleme
   * Three.js Line2 ile 3D çizgi çizimi
   */
  ac3DLineDialog(duzenleModu: boolean = false, mevcutCizgi?: any): void {
    // Bildirim gönder
    this.bildirim.aracKullanildi('3D Çizgi');
    this.komutKampanya('CIZIM', 'cizgi_3d', '3D Çizgi / Polyline / Spline');

    // Düzenleme modunda aynı çizgi için tek dialog açılmasını sağla
    // Oluşturma modunda da tek dialog açılmasını sağla
    const dialogId = duzenleModu && mevcutCizgi
      ? 'fiko-3d-line-edit-' + mevcutCizgi.uuid
      : 'fiko-3d-line-dialog-create';

    // Mevcut dialog varsa öne getir
    const mevcutDialog = this.DialogFiko.idIleAl(dialogId);
    if (mevcutDialog && mevcutDialog.miAcik) {
      // Dialog zaten açık, sayfadaki en yüksek z-index'i bulup öne getir
      const dialogEl = document.getElementById(mevcutDialog.id_dialog);
      if (dialogEl) {
        // overlayZIndexAl: Sayfadaki TÜM elementleri tarar
        const yeniZIndex = this.DialogFiko.overlayZIndexAl?.() || 99999;
        dialogEl.style.setProperty('z-index', yeniZIndex.toString(), 'important');
        const parent = dialogEl.parentElement;
        if (parent) {
          parent.style.setProperty('z-index', yeniZIndex.toString(), 'important');
        }
        this.DialogFiko.dialogTiklandi?.(mevcutDialog);
        dialogEl.focus();
      }
      return;
    }

    // Yeni dialog aç
    this.DialogFiko.ac({
      bilesen: FikoYT3dLineDialogComponent,
      id: dialogId,
      ayarlar: {
        baslik: duzenleModu ? 'Çizgi Düzenle' : '3D Çizgi',
        simge: 'pencil',
        modalMi: false,
        sinirlandi: false,
        boyut: { w: 220, h: 'auto' }
      },
      parametreler: {
        anaGosterim: this.fikoThreejs,
        duzenleModu: duzenleModu,
        mevcutCizgi: mevcutCizgi
      }
    });
  }

  /**
   * 3D Polyline Dialog - FikoYT 3D Polyline oluşturma ve düzenleme
   * Çoklu nokta ile oluşturulan polyline (çoklu çizgi) araçları
   */
  ac3DPolylineDialog(duzenleModu: boolean = false, mevcutPolyline?: any): void {
    // Bildirim gönder
    this.bildirim.aracKullanildi('3D Polyline');
    this.komutKampanya('CIZIM', 'cizgi_3d', '3D Çizgi / Polyline / Spline');

    // Düzenleme modunda aynı polyline için tek dialog açılmasını sağla
    // Oluşturma modunda da tek dialog açılmasını sağla
    const dialogId = duzenleModu && mevcutPolyline
      ? 'fiko-3d-polyline-edit-' + mevcutPolyline.uuid
      : 'fiko-3d-polyline-dialog-create';

    // Mevcut dialog varsa öne getir
    const mevcutDialog = this.DialogFiko.idIleAl(dialogId);
    if (mevcutDialog && mevcutDialog.miAcik) {
      // Dialog zaten açık, sayfadaki en yüksek z-index'i bulup öne getir
      const dialogEl = document.getElementById(mevcutDialog.id_dialog);
      if (dialogEl) {
        // overlayZIndexAl: Sayfadaki TÜM elementleri tarar
        const yeniZIndex = this.DialogFiko.overlayZIndexAl?.() || 99999;
        dialogEl.style.setProperty('z-index', yeniZIndex.toString(), 'important');
        const parent = dialogEl.parentElement;
        if (parent) {
          parent.style.setProperty('z-index', yeniZIndex.toString(), 'important');
        }
        this.DialogFiko.dialogTiklandi?.(mevcutDialog);
        dialogEl.focus();
      }
      return;
    }

    // Yeni dialog aç
    this.DialogFiko.ac({
      bilesen: FikoYT3dPolylineDialogComponent,
      id: dialogId,
      ayarlar: {
        baslik: duzenleModu ? 'Polyline Düzenle' : '3D Polyline',
        simge: 'share alternate',
        modalMi: false,
        sinirlandi: false,
        boyut: { w: 360, h: 'auto' }
      },
      parametreler: {
        anaGosterim: this.fikoThreejs,
        duzenleModu: duzenleModu,
        mevcutPolyline: mevcutPolyline
      }
    });
  }

  /**
   * 3D Spline Dialog - FikoYT 3D Spline olusturma ve duzenleme
   * Catmull-Rom ve Bezier egrileri ile smooth curve olusturma
   */
  ac3DSplineDialog(duzenleModu: boolean = false, mevcutSpline?: any): void {
    // Bildirim gonder
    this.bildirim.aracKullanildi('3D Spline');
    this.komutKampanya('CIZIM', 'cizgi_3d', '3D Çizgi / Polyline / Spline');

    // Duzenleme modunda ayni spline icin tek dialog acilmasini sagla
    // Olusturma modunda da tek dialog acilmasini sagla
    const dialogId = duzenleModu && mevcutSpline
      ? 'fiko-3d-spline-edit-' + mevcutSpline.uuid
      : 'fiko-3d-spline-dialog-create';

    // Mevcut dialog varsa one getir
    const mevcutDialog = this.DialogFiko.idIleAl(dialogId);
    if (mevcutDialog && mevcutDialog.miAcik) {
      // Dialog zaten acik, sayfadaki en yuksek z-index'i bulup one getir
      const dialogEl = document.getElementById(mevcutDialog.id_dialog);
      if (dialogEl) {
        // overlayZIndexAl: Sayfadaki TUM elementleri tarar
        const yeniZIndex = this.DialogFiko.overlayZIndexAl?.() || 99999;
        dialogEl.style.setProperty('z-index', yeniZIndex.toString(), 'important');
        const parent = dialogEl.parentElement;
        if (parent) {
          parent.style.setProperty('z-index', yeniZIndex.toString(), 'important');
        }
        this.DialogFiko.dialogTiklandi?.(mevcutDialog);
        dialogEl.focus();
      }
      return;
    }

    // Yeni dialog ac
    this.DialogFiko.ac({
      bilesen: FikoYT3dSplineDialogComponent,
      id: dialogId,
      ayarlar: {
        baslik: duzenleModu ? 'Spline Duzenle' : '3D Spline',
        simge: 'wave square',
        modalMi: false,
        sinirlandi: false,
        boyut: { w: 380, h: 'auto' }
      },
      parametreler: {
        anaGosterim: this.fikoThreejs,
        duzenleModu: duzenleModu,
        mevcutSpline: mevcutSpline
      }
    });
  }

  /**
   * Screenshot Dialog - 3D Viewport'un PNG/JPEG olarak export edilmesi
   * Yüksek çözünürlük (1x, 2x, 4x) ve transparan arka plan desteği
   */
  acScreenshotDialog(): void {
    // Bildirim gönder
    this.bildirim.aracKullanildi('Screenshot');

    this.DialogFiko.ac({
      bilesen: FikoScreenshotComponent,
      id: 'fiko-screenshot-dialog',
      ayarlar: {
        baslik: 'Ekran Yakalama',
        simge: 'camera',
        modalMi: false,
        sinirlandi: false,
        boyut: { w: 200, h: 'auto' }
      },
      parametreler: {
        anaGosterim: this.fikoThreejs
      }
    });
  }

  /**
   * Video Kayıt Dialog - 3D Viewport'un WebM video olarak kaydedilmesi
   * Kalite seçimi (Düşük/Orta/Yüksek), FPS (30/60)
   */
  acVideoKayitDialog(): void {
    // Bildirim gönder
    this.bildirim.aracKullanildi('Video Kayıt');

    this.DialogFiko.ac({
      bilesen: FikoVideoRecordComponent,
      id: 'fiko-video-record-dialog',
      ayarlar: {
        baslik: 'Video Kayıt',
        simge: 'video',
        modalMi: false,
        sinirlandi: false,
        boyut: { w: 260, h: 'auto' }
      },
      parametreler: {
        anaGosterim: this.fikoThreejs
      }
    });
  }

  /**
   * Mass Info Dialog - Hacim, Yüzey Alanı, Kütle Merkezi ve Ağırlık
   * Mesh geometrisinden fiziksel özellik hesaplama
   */
  acMassInfoDialog(): void {
    // Bildirim gönder
    this.bildirim.aracKullanildi('Kütle Bilgisi');
    this.komutKampanya('OLCUM', 'agirlik', 'Ağırlık (Uzun-bas kg/ölçü)');

    this.DialogFiko.ac({
      bilesen: FikoMassInfoComponent,
      id: 'fiko-mass-info-dialog',
      ayarlar: {
        baslik: 'Kütle Bilgisi',
        simge: 'balance scale',
        modalMi: false,
        sinirlandi: false,
        boyut: { w: 220, h: 'auto' }
      },
      parametreler: {
        anaGosterim: this.fikoThreejs
      }
    });
  }

  /** Kayıtlı Belgeler — teklif/iş emri/muayene/üretim kartı kayıtları (DB+local), yükle/sil. */
  acKayitlarDialog(baslangicTip?: string): void {
    this.bildirim.aracKullanildi('Kayıtlı Belgeler');
    this.DialogFiko.ac({
      bilesen: FikoKayitlarComponent,
      id: 'fiko-kayitlar-dialog',
      ayarlar: { baslik: 'Kayıtlı Belgeler', simge: 'folder open', modalMi: false, sinirlandi: false, boyut: { w: 380, h: 'auto' } },
      parametreler: { ana: this, baslangicTip }
    });
  }

  /** Üretim & Maliyet menüsü — tüm katma-değer modüllerini tek açılır listede toplar. */
  acUretimMenu(): void {
    this.bildirim.aracKullanildi('Üretim & Maliyet Menü');
    this.DialogFiko.ac({
      bilesen: FikoUretimMenuComponent,
      id: 'fiko-uretim-menu-dialog',
      ayarlar: { baslik: 'Üretim & Maliyet', simge: 'factory', modalMi: false, sinirlandi: false, boyut: { w: 300, h: 'auto' } },
      parametreler: { ana: this }
    });
  }

  /** Cıvata/Diş Standardı + Tork — metrik diş tablosu (adım/tap/geçme) + sıkma torku. */
  acCivataDialog(): void {
    this.bildirim.aracKullanildi('Cıvata/Diş Standardı');
    this.DialogFiko.ac({
      bilesen: FikoCivataComponent,
      id: 'fiko-civata-dialog',
      ayarlar: { baslik: 'Cıvata / Diş + Tork', simge: 'wrench', modalMi: false, sinirlandi: false, boyut: { w: 330, h: 'auto' } },
      parametreler: { anaGosterim: this.fikoThreejs }
    });
  }

  /** Birim Çevirici — uzunluk/ağırlık/basınç/kuvvet/sıcaklık/açı dönüşümü. */
  acBirimDialog(): void {
    this.bildirim.aracKullanildi('Birim Çevirici');
    this.DialogFiko.ac({
      bilesen: FikoBirimComponent,
      id: 'fiko-birim-dialog',
      ayarlar: { baslik: 'Birim Çevirici', simge: 'exchange', modalMi: false, sinirlandi: false, boyut: { w: 320, h: 'auto' } },
      parametreler: { anaGosterim: this.fikoThreejs }
    });
  }

  /** Kesme Parametreleri (Speeds & Feeds) — malzeme+takım → devir (RPM) + ilerleme. */
  acKesmeParametreDialog(): void {
    this.bildirim.aracKullanildi('Kesme Parametreleri');
    this.komutKampanya('CAM', 'kesme_parametre', 'CNC Kesme Parametreleri (Speeds & Feeds)');
    this.DialogFiko.ac({
      bilesen: FikoKesmeParametreComponent,
      id: 'fiko-kesme-parametre-dialog',
      ayarlar: { baslik: 'Kesme Parametreleri', simge: 'cog', modalMi: false, sinirlandi: false, boyut: { w: 330, h: 'auto' } },
      parametreler: { anaGosterim: this.fikoThreejs }
    });
  }

  /** Üretim Takvimi / Termin — iş listesi + kapasite → iş günü + teslim tarihi. */
  acTakvimDialog(): void {
    this.bildirim.aracKullanildi('Üretim Takvimi');
    this.komutKampanya('ANALIZ', 'uretim_takvimi', 'Üretim Takvimi / Termin Planı');
    this.DialogFiko.ac({
      bilesen: FikoTakvimComponent,
      id: 'fiko-takvim-dialog',
      ayarlar: { baslik: 'Üretim Takvimi', simge: 'calendar alternate', modalMi: false, sinirlandi: false, boyut: { w: 340, h: 'auto' } },
      parametreler: { anaGosterim: this.fikoThreejs }
    });
  }

  /** Üretim Kartı (Dashboard) — modeli uçtan uca analiz: geometri+özellik+maliyet tek kart. */
  acUretimKartiDialog(): void {
    this.bildirim.aracKullanildi('Üretim Kartı');
    this.komutKampanya('ANALIZ', 'uretim_karti', 'Üretim Kartı / Maliyet Dashboard');
    this.DialogFiko.ac({
      bilesen: FikoUretimKartiComponent,
      id: 'fiko-uretim-karti-dialog',
      ayarlar: { baslik: 'Üretim Kartı', simge: 'clipboard list', modalMi: false, sinirlandi: false, boyut: { w: 360, h: 'auto' } },
      parametreler: { anaGosterim: this.fikoThreejs, modelleme: this.modellemeAl(), ana: this }
    });
  }

  /** Büküm Açınımı — sac metal flanş+büküm → düz açınım boyu (bend allowance). */
  acBukumDialog(): void {
    this.bildirim.aracKullanildi('Büküm Açınımı');
    this.komutKampanya('ANALIZ', 'bukum_acinim', 'Sac Metal Büküm Açınımı');
    this.DialogFiko.ac({
      bilesen: FikoBukumComponent,
      id: 'fiko-bukum-dialog',
      ayarlar: { baslik: 'Büküm Açınımı', simge: 'level down alternate', modalMi: false, sinirlandi: false, boyut: { w: 340, h: 'auto' } },
      parametreler: { anaGosterim: this.fikoThreejs }
    });
  }

  /** Yüzey İşlem/Kaplama Maliyeti — alan/ağırlık × işlem birim fiyatı + min ücret. */
  acKaplamaDialog(): void {
    this.bildirim.aracKullanildi('Kaplama Maliyeti');
    this.komutKampanya('ANALIZ', 'kaplama_maliyeti', 'Yüzey İşlem/Kaplama Maliyeti');
    this.DialogFiko.ac({
      bilesen: FikoKaplamaComponent,
      id: 'fiko-kaplama-dialog',
      ayarlar: { baslik: 'Kaplama Maliyeti', simge: 'paint roller', modalMi: false, sinirlandi: false, boyut: { w: 350, h: 'auto' } },
      parametreler: { anaGosterim: this.fikoThreejs, modelleme: this.modellemeAl() }
    });
  }

  /** Kesim Maliyeti (Lazer/Plazma/Su Jeti) — çevre+delme → süre+maliyet. */
  acKesimDialog(): void {
    this.bildirim.aracKullanildi('Kesim Maliyeti');
    this.komutKampanya('CAM', 'kesim_maliyeti', 'Lazer/Plazma/Su Jeti Kesim Maliyeti');
    this.DialogFiko.ac({
      bilesen: FikoKesimComponent,
      id: 'fiko-kesim-dialog',
      ayarlar: { baslik: 'Kesim Maliyeti', simge: 'cut', modalMi: false, sinirlandi: false, boyut: { w: 350, h: 'auto' } },
      parametreler: { anaGosterim: this.fikoThreejs, modelleme: this.modellemeAl() }
    });
  }

  /** DXF Dışa Aktarma — model kenarlarını 2D DXF (üst/ön/yan) indir. */
  acDxfDialog(): void {
    this.bildirim.aracKullanildi('DXF Dışa Aktar');
    this.komutKampanya('CIZIM', 'dxf_disa', 'DXF Dışa Aktarma');
    this.DialogFiko.ac({
      bilesen: FikoDxfComponent,
      id: 'fiko-dxf-dialog',
      ayarlar: { baslik: 'DXF Dışa Aktar', simge: 'file outline', modalMi: false, sinirlandi: false, boyut: { w: 340, h: 'auto' } },
      parametreler: { anaGosterim: this.fikoThreejs, modelleme: this.modellemeAl() }
    });
  }

  /** Malzeme/Maliyet/CO2 Karşılaştırma — modeli ölç → tüm malzemelerde ağırlık/maliyet/karbon. */
  acMalzemeKarsilastirDialog(): void {
    this.bildirim.aracKullanildi('Malzeme Karşılaştırma');
    this.komutKampanya('ANALIZ', 'malzeme_karsilastir', 'Malzeme/Maliyet/CO₂ Karşılaştırma');
    this.DialogFiko.ac({
      bilesen: FikoMalzemeKarsilastirComponent,
      id: 'fiko-malzeme-karsilastir-dialog',
      ayarlar: { baslik: 'Malzeme Karşılaştır', simge: 'leaf', modalMi: false, sinirlandi: false, boyut: { w: 350, h: 'auto' } },
      parametreler: { anaGosterim: this.fikoThreejs, modelleme: this.modellemeAl() }
    });
  }

  /** QR İş Emri & Etiket — parça künyesi + QR + operasyonlar → yazdırılabilir iş emri/etiket. */
  acIsEmriDialog(): void {
    this.bildirim.aracKullanildi('İş Emri (QR)');
    this.komutKampanya('CIZIM', 'is_emri', 'QR İş Emri & Etiket');
    this.DialogFiko.ac({
      bilesen: FikoIsEmriComponent,
      id: 'fiko-is-emri-dialog',
      ayarlar: { baslik: 'QR İş Emri', simge: 'qrcode', modalMi: false, sinirlandi: false, boyut: { w: 350, h: 'auto' } },
      parametreler: { anaGosterim: this.fikoThreejs, modelleme: this.modellemeAl() }
    });
  }

  /** Tolerans Yığını (1D Stack-up) — ölçü zinciri → worst-case + RSS boşluk analizi. */
  acToleransDialog(): void {
    this.bildirim.aracKullanildi('Tolerans Yığını');
    this.komutKampanya('OLCUM', 'tolerans_yigini', 'Tolerans Yığını (Stack-up)');
    this.DialogFiko.ac({
      bilesen: FikoToleransComponent,
      id: 'fiko-tolerans-dialog',
      ayarlar: { baslik: 'Tolerans Yığını', simge: 'sort amount up', modalMi: false, sinirlandi: false, boyut: { w: 350, h: 'auto' } },
      parametreler: { anaGosterim: this.fikoThreejs }
    });
  }

  /** Muayene Raporu (FAI/PPAP) — nominal±tol vs ölçülen → geç/kal + yazdırma. */
  acMuayeneDialog(): void {
    this.bildirim.aracKullanildi('Muayene Raporu');
    this.komutKampanya('OLCUM', 'muayene', 'Muayene Raporu (FAI/PPAP)');
    this.DialogFiko.ac({
      bilesen: FikoMuayeneComponent,
      id: 'fiko-muayene-dialog',
      ayarlar: { baslik: 'Muayene Raporu (FAI)', simge: 'clipboard check', modalMi: false, sinirlandi: false, boyut: { w: 450, h: 'auto' } },
      parametreler: { anaGosterim: this.fikoThreejs, modelleme: this.modellemeAl() }
    });
  }

  /** Nesting — parçaları levhaya en az fire ile yerleştir (MaxRects) + SVG görsel. */
  acNestingDialog(): void {
    this.bildirim.aracKullanildi('Nesting');
    this.komutKampanya('ANALIZ', 'nesting', 'Levha Yerleşim Optimizasyonu');
    this.DialogFiko.ac({
      bilesen: FikoNestingComponent,
      id: 'fiko-nesting-dialog',
      ayarlar: { baslik: 'Nesting / Yerleşim', simge: 'th', modalMi: false, sinirlandi: false, boyut: { w: 390, h: 'auto' } },
      parametreler: { anaGosterim: this.fikoThreejs, modelleme: this.modellemeAl() }
    });
  }

  /** Oto Özellik Tanıma — B-Rep'ten delik/cep/düzlem tanı → tek tıkla CAM operasyonu. */
  acFeatureTaniDialog(): void {
    this.bildirim.aracKullanildi('Özellik Tanıma');
    this.komutKampanya('ANALIZ', 'feature_tani', 'Otomatik Özellik Tanıma → CAM');
    this.DialogFiko.ac({
      bilesen: FikoFeatureTaniComponent,
      id: 'fiko-feature-tani-dialog',
      ayarlar: { baslik: 'Özellik Tanıma', simge: 'search', modalMi: false, sinirlandi: false, boyut: { w: 290, h: 'auto' } },
      parametreler: {
        anaGosterim: this.fikoThreejs,
        modelleme: this.modellemeAl(),
        ana: this,
        camAc: (tip: 'delik' | 'yuzey') => { this.ac2DCamDialog(tip === 'delik' ? 'delik' : 'cep'); }
      }
    });
  }

  /** Anlık Teklif/Maliyet Motoru — model → ağırlık+malzeme+işleme → fiyat teklifi + PDF. */
  acTeklifDialog(): void {
    this.bildirim.aracKullanildi('Teklif Motoru');
    this.komutKampanya('ANALIZ', 'teklif', 'Anlık Teklif/Maliyet Motoru');
    this.DialogFiko.ac({
      bilesen: FikoTeklifComponent,
      id: 'fiko-teklif-dialog',
      ayarlar: { baslik: 'Anlık Teklif', simge: 'calculator', modalMi: false, sinirlandi: false, boyut: { w: 320, h: 'auto' } },
      parametreler: { anaGosterim: this.fikoThreejs, modelleme: this.modellemeAl(), ana: this }
    });
  }

  /**
   * PDF Şablon Editörü - Yeni sekmede açılır, ana sayfa ile bağlantılı
   * BroadcastChannel ile screenshot, ölçüm ve model bilgisi alışverişi
   */
  acPdfEditorDialog(): void {
    // Bildirim gönder
    this.bildirim.aracKullanildi('PDF Editör');

    // Editörü yeni sekmede aç
    const editorWindow = openPdfEditorWindow(window.location.origin);

    if (!editorWindow) {
      alert('PDF Editör penceresi açılamadı. Popup engelleyicinizi kontrol edin.');
    }
  }

  /**
   * Teknik Resim Editörü - CATIA CATDrawing benzeri sistem
   * 3D modelden 2D teknik resim oluşturma
   * YENİ: Artık ana 3D viewer içinde çalışıyor (Three.js tabanlı)
   */
  acTeknikResimDialog(): void {
    // Bildirim gönder
    this.bildirim.aracKullanildi('Teknik Resim');
    this.komutKampanya('CIZIM', 'teknik_resim', '2D Teknik Resim Çıktısı');

    // Toolbar'ı toggle et
    if (this.teknikResimToolbarRef) {
      this.teknikResimToolbarRef.toggle();
    } else {
      console.warn('[FikoYT3D] Teknik Resim Toolbar bulunamadı');
    }
  }

  /**
   * CMM Tarama Dialog - Mobil kamera ile 3D tarama sistemi
   * WebRTC ile cep telefonu kamerası bağlantısı, point cloud oluşturma
   */
  acCMMTaramaDialog(): void {
    // Bildirim gönder
    this.bildirim.aracKullanildi('CMM Tarama');
    this.komutKampanya('OLCUM', 'cmm_tarama', 'Canlı Tarama (Mobil CMM Kamera)');

    // CMM Dialog'ı aç
    this.DialogFiko.ac({
      bilesen: FikoCMMDialogComponent,
      id: 'fiko-cmm-tarama-dialog',
      ayarlar: {
        baslik: 'Canlı Tarama',
        simge: 'camera',
        modalMi: false,
        sinirlandi: false,
        boyut: { w: 280, h: 'auto' }
      },
      parametreler: {
        anaGosterim: this.fikoThreejs
      }
    });
  }

  /**
   * 2D CAM Sistemi Dialog - CNC işleme için 2D CAM araçları
   * Toolpath oluşturma, G-code üretimi, profil ve cep işleme
   */
  ac2DCamDialog(baslangicAktivite?: string): void {
    // Bildirim gönder
    this.bildirim.aracKullanildi('2D CAM');
    this.komutKampanya('CAM', 'cam_2d', '2D CAM (Cep/Kontur/Delik)');

    this.DialogFiko.ac({
      bilesen: Fiko2DCamComponent,
      id: 'fiko-2d-cam-dialog',
      ayarlar: {
        baslik: '2D CAM Sistemi',
        simgeResim: '/simgeler/logo.webp',
        modalMi: false,
        sinirlandi: false,
        boyut: { w: 380, h: 'auto' }
      },
      parametreler: {
        anaGosterim: this.fikoThreejs,
        baslangicAktivite   // CAM workbench'ten gelen aktivite tipi (profil/cep/delik/gravur/gcode)
      }
    });
  }

  /** Döküm Kontrol — dialog yok, doğrudan 3D viewport'a gömülü tam overlay */
  dokumKontrolAcik = false;

  acDokumKontrolDialog(): void {
    this.bildirim.aracKullanildi('Döküm Kontrol');
    this.komutKampanya('ANALIZ', 'dokum_kontrol', 'Döküm Kontrol Modülü');
    this.dokumKontrolAcik = !this.dokumKontrolAcik;
    this.CD?.detectChanges?.();
  }

  dokumKontrolKapat(): void {
    this.dokumKontrolAcik = false;
    this.CD?.detectChanges?.();
  }

  acDokumSimulasyonuDialog(): void {
    this.bildirim.aracKullanildi('Döküm Simülasyonu');

    this.DialogFiko.ac({
      bilesen: FikoSPHSiviComponent,
      id: 'fiko-dokum-simulasyon-dialog',
      ayarlar: {
        baslik: 'Döküm Simülasyonu',
        simgeResim: '/simgeler/logo.webp',
        modalMi: false,
        sinirlandi: false,
        boyut: { w: 420, h: 'auto' }
      },
      parametreler: {
        anaGosterim: this.fikoThreejs
      }
    });
  }

  // ═══════════════════════════════════════════════════════════════════
  // 3D-TREE SYNC: Tree event handlers
  // ═══════════════════════════════════════════════════════════════════

  /**
   * Tree item hover olduğunda 3D'de highlight göster
   */
  onTreeItemHover(grup: any): void {
    const secimler = this.fikoThreejs?.sahneler?.[0]?.secimler;
    if (secimler && grup) {
      secimler.hoverFromTree(grup.uuid);
    } else if (secimler) {
      secimler.hoverFromTree(null);
    }
  }

  /**
   * Tree item tıklandığında 3D'de seçim yap
   */
  onTreeItemSelect(event: { grup: any, ctrlKey: boolean }): void {
    const secimler = this.fikoThreejs?.sahneler?.[0]?.secimler;
    if (secimler && event.grup) {
      secimler.selectFromTree(event.grup.uuid);
    }
  }

  /**
   * Ürün ağacı container'ına tıklandığında
   * Boş alana tıklanırsa seçimi temizle
   */
  onTreeContainerClick(event: MouseEvent): void {
    // Panel görünür değilse işlem yapma
    if (!this.solAracCubuguAcik) return;

    const target = event.target as HTMLElement;

    // Tree item'a tıklandıysa (text, tree-item-container, icon vb.) seçimi temizleme
    // Sadece boş alana tıklandığında temizle
    const isTreeItem = target.closest('.tree-item-container') ||
                       target.closest('.text') ||
                       target.closest('.item');

    // Boş alana tıklandıysa seçimi temizle
    if (!isTreeItem) {
      const secimler = this.fikoThreejs?.sahneler?.[0]?.secimler;
      if (secimler) {
        secimler.selectFromTree(null);
      }
    }
  }
}
